<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image2" /> -->
    <transition
        appear
        @before-enter="$animations.beforeEnterLogoArea"
        @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition
        appear
        @before-enter="$animations.beforeEnterAbove"
        @enter="$animations.enterAbove"
    >
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img
              src="../assets/images/icons/updatedIcons/normalFlow/previewPage.png"
              alt="document.png"
              width="80%"
          />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img
              src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37575.png"
              alt="document.png"
              width="70%"
          />
        </div>
      </div>
    </transition>
    <div class="card px-6" >
      <transition
          appear
          @before-enter="$animations.beforeEnterAbove"
          @enter="$animations.enterAbove"
      >
        <div class="columns is-centered">
          <div class="column is-full ps-6" style="text-align: center">
            <img
                src="../assets/images/icons/Blue/Group 163.png"
                alt="contact-info-img"
                width="70"
                height="70"
            />
            <p
                :class="`text-center mx-3 mb-2 ${
                $root.selectedLanguage === `ta`
                  ? `ta-he-line`
                  : $root.selectedLanguage === `si`
                  ? `si-he-line`
                  : `en-he-line`
              }`"
                style="font-family: OpenSans-Bold; "
            >
              {{ $root.selectedLanguageData.preview }}
            </p>
            <p
                :class="`text-center mx-3 ${
                $root.selectedLanguage === `ta`
                  ? `ta-sub-line`
                  : $root.selectedLanguage === `si`
                  ? `si-sub-line`
                  : `en-sub-line`
              }`"
                style="font-family: OpenSans-Bold; "
            >
              {{ $root.selectedLanguageData.checkifalldetailsarecorrect }}
            </p>
            <p style="font-family: OpenSans-Regular; ">
              {{ $root.selectedLanguageData.dataEditByButtonForPreviewPage }}
            </p>
          </div>
        </div>
      </transition>

      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="onSubmit">
          <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
          >
            <div class="columns is-left">
              <div class="column is-half ps-5">
                <div class="is-flex flexName" >
                  <!-- <figure class="image is-128x128">
                  <img
                    style="border: 1px solid #eebe2c"
                    class="is-rounded"
                    :src="
                      $root.imageurl.selfie_imageurl
                        ? $root.imageurl.selfie_imageurl
                        : selfieImageSample
                    "
                  />
                </figure> -->

                  <img

                      v-if="$root.imageurl.selfie_imageurl"
                      :src="$root.imageurl.selfie_imageurl"
                      class="round-image-box"
                  />

                  <div class="ml-4 mt-6 content-container" style="width: 100%;">
                    <p class="nameSize"

                    >
                      {{ getFullname() || "Jasom Carter " }}
                    </p>

                    <hr
                        :style="{
                        'background-color': '#1b1b1b',
                        height: '0.92px',
                        'margin-top': '0',
                        'width': '30vw',
                        'padding-top': '0',
                        'margin-bottom': '0',
                        'padding-bottom': '0',
                      }"
                    />
                    <p class="mobileSize">
                      <img
                          src="../assets/images/icons/black/Group 156.png"
                          alt="call.img"
                          width="17rem"
                          class=" mr-1"
                      />
                      <span class="pr-4 line">{{ $root.formData.mobileNumber || '+94756449652' }}</span>

                      <!-- Email address -->
                      <img
                          src="../assets/images/icons/black/Message.png"
                          alt="Message.img"
                          width="17rem"
                          class="ml-4 mr-1"
                      />
                      {{ $root.formData.email || 'jasomcarter@gmail.com' }}
                    </p>


                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="columns">
            <transition
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
            >


              <div class="column pt-3 ps-5">
                <p class="preview-page-title">Account Selection</p>

                <!-- contact number start here -->
                <div class=" mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.mobileNumber
                    }}</label>

                  <div class="columns is-7 is-variable">
                    <div class="column is-3">
                      <div>
                        <section>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-autocomplete  maxlength="10" icon-pack="fi" v-model="$root.formData.countryCode" :icon="$root.formData.countryIconString" disabled>
                              </b-autocomplete>
                              <span class="icon is-small is-right mr-2">
                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />
                            </span>

                            </p>
                          </b-field>

                        </section>

                      </div>
                    </div>
                    <div class="column is-5">
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input v-model="$root.formData.mobileNumberWithoutCountryCode" type="tel" disabled/>
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

                          <!-- <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed
                            to start with 0</span> -->

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
                <!-- contact number end here -->

                <!--                email start here -->
                <div class="is-one-two">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.emailAddress
                    }}</label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.email"
                        s
                    />
                  </b-field>
                </div>
                <!--                email end here-->

                <div class="field mt-5  ">
                  <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.do_you_have_nic}}</label>
                  <div class="columns">
                    <div class="column is-one-two" v-if="$root.formData.haveNic == 'Yes'">
                      <b-field>
                        <b-radio name="have nic" style="font-family: OpenSans-Regular"
                                 disabled
                                 native-value="Yes"
                                 v-model="$root.formData.haveNic">
                          {{$root.selectedLanguageData.yes }}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-one-two" v-if="$root.formData.haveNic == 'No'">
                      <b-field>
                        <b-radio name="have nic" style="font-family: OpenSans-Regular"
                                 disabled
                                 native-value="No"
                                 v-model="$root.formData.haveNic">
                          {{ $root.selectedLanguageData.no }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>

                <div class="columns" v-if="$root.formData.customer_nic !== ''">
                  <div class="column">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.nic_number
                      }}
                    </label>
                    <b-input disabled v-model="$root.formData.customer_nic"></b-input>
                  </div>
                </div>

                <hr>

                <!-- curruncy type and preferd branch start here -->

                <div class="columns">
                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.currencyType
                      }}
                    </label>
                    <b-input disabled placeholder="LKR"></b-input>
                  </div>


                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.preferredBranch
                      }}
                    </label>
                    <b-input disabled   @focus="$inputFocused('branch')"
                             @input="$inputChanged('branch')"
                             @blur="$inputBlured('branch')"
                             v-model="$root.formData.branch"></b-input>
                  </div>
                </div>

                <!-- curruncy type and preferd branch end here -->
                   <div class="field mt-4" >
                <!--                  v-if="$root.kycFieldVisibility.politically_exposed_relative"-->
                <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{
                    $root.selectedLanguageData
                        .youAreGoningToOpen
                  }}<span class="has-text-danger">*</span></label>
               
                  <div class="columns">
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="Opened account" style="font-family: OpenSans-Regular" native-value="Individual Account" disabled
                                 v-model="$root.formData.opendAccountType">
                          {{ $root.selectedLanguageData.individualAccount }}
                        </b-radio></b-field>
                    </div>

                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="Opened account" style="font-family: OpenSans-Regular" native-value="Joint Account"
                                 v-model="$root.formData.opendAccountType"
                                 disabled
                     >
                          {{ $root.selectedLanguageData.jointAccount }}
                        </b-radio></b-field>
                    </div>
                  </div>
              </div>


                <!-- Account type and account start here -->

                <div class="mt-4 columns">
                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.accountType
                      }}
                    </label>

                    <div>
                      <b-select  disabled style="width: 100%" expanded v-model="$root.formData.account_type">
                        <option value="Savings Account">
                          {{ $root.selectedLanguageData.savingsAccounts }}
                        </option>
                        <option value="Fixed Account">
                          {{$root.selectedLanguageData.fixedAccounts }}
                        </option>
                      </b-select>
                    </div>


                  </div>
                  <div v-if="$root.formData.account_type === `Savings Account`" class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.account
                      }}
                    </label>
                    <div>

                      <b-select disabled style="width: 100%" expanded v-model="$root.formData.account">
                        <option value="Minor Savings">
                          {{ $root.selectedLanguageData.childrensSavings }}
                        </option>
                        <option value="Normal Savings">
                          {{ $root.selectedLanguageData.normalSavings }}
                        </option>
                        <option value="Investment Savingss">
                          {{ $root.selectedLanguageData.invesmentSavings }}
                        </option>
                      </b-select>

                    </div>
                  </div>
                </div>


                <div>
                  <div class="tile is-parent">
                    <b-field>
                      <div class="tile is-child box my-2" >
                        <figure class="image is-128x128">
                          <img :src="$root.formData.accountImage" style="padding-top: 20px;">
                        </figure>
                      </div>
                    </b-field>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <b-radio disabled name="accountRadio" style="font-family: OpenSans-Regular" :native-value="$root.formData.account_name"
                                 v-model="$root.formData.account_name">
                          {{ $root.formData.account_name}}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>

                <!--                If account type is fixed this time plan will show-->
                <div class="mt-4 columns"  v-if="$root.formData.account_type === `Fixed Account`">
                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.timePeriod
                      }}
                    </label>

                    <div>
                      <b-input  disabled style="width: 100%" v-model="$root.formData.account_time_period">
                      </b-input>
                    </div>


                  </div>
                </div>


          <div v-if="$root.formData.account_type === `Fixed Account`">
  <hr>
    <div class="columns">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.interestPaymentAt
                  }}<span class="has-text-danger">*</span></label>
                 
          <b-select v-model="$root.formData.interestPayment" expanded disabled>
             <option
                        v-for="payment in $root.selectedLanguageData
                          .interestPaymentsList"
                        :key="payment.value"
                        :value="payment.value"
                      >
                        {{ payment.langTranslation }}
                      </option>
          </b-select>
   

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.interestPayableMethod
                  }}<span class="has-text-danger">*</span></label>
                  
          <b-select v-model="$root.formData.interestPayable" expanded disabled>
           <option
                        v-for="payable in $root.selectedLanguageData
                          .interestPayableList"
                        :key="payable.value"
                        :value="payable.value"
                      >
                        {{ payable.langTranslation }}
                      </option>
          </b-select>
          
      </div>
    </div>

           <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.selectTansferAccount}}
                    <span class="has-text-danger">*</span>
                  </label>

                  <div class="columns">
                    <div class="column is-4">
                      <b-field>
                       
                          <b-radio
                              disabled
                              name="Transfer Account" style="font-family: OpenSans-Regular" native-value="RDB"
                                   @focus="$inputFocused('nomineeGender')" 
                                   @blur="$inputBlured('nomineeGender')" v-model="$root.formData.transferAccount"
                                   @input="branchAndBranchListClearHandler()">
                            {{$root.selectedLanguageData.rdbBankAccount }}
                          </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <b-field>
   
                          <b-radio name="Transfer Account" style="font-family: OpenSans-Regular" native-value="Other"
                          disabled
                                   @focus="$inputFocused('nomineeGender')" 
                                   @blur="$inputBlured('nomineeGender')" v-model="$root.formData.transferAccount" >
                            {{ $root.selectedLanguageData.otherBankAccount }}
                          </b-radio>
                    
                      </b-field>
                    </div>
                  </div>
                </div>

                  <div class="columns" v-if="$root.formData.transferAccount === 'Other'">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.bank
                  }}<span class="has-text-danger">*</span></label>
          <b-select v-model="$root.formData.otherBank" expanded @input="otherBanksBranchFilterHandler()" disabled>

                <option
                            v-for="bank in $root.dataLists.otherBankAndBranchList"
                            :value="bank.bank_name"
                            :key="bank">
                          {{ bank.bank_name}}
                        </option>
          </b-select>

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.branch
                  }}<span class="has-text-danger">*</span></label>
          <b-select v-model="$root.formData.otherBankBranch" expanded disabled>

               <option
                            v-for="bankBranch in $root.dataLists.selectBankBranches"
                            :value="bankBranch"
                            :key="bankBranch">
                          {{ bankBranch.branch_name}}
                        </option>

          </b-select>
      </div>
    </div>


     <div class="columns" v-if="$root.formData.transferAccount === 'Other'">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.accountNumber
                  }}
                  <span class="has-text-danger">*</span>
                </label>
                   <b-field>
                  <p class="control has-icons-right">
          
          <b-input v-model="$root.formData.otherBankAccountNumber" disabled/>
           <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />

                            </span>
                    
          </p>
          </b-field>

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.accountHolderName
                  }}<span class="has-text-danger">*</span></label>
                   <b-field>
                  <p class="control has-icons-right">
                 
          <b-input v-model="$root.formData.otherBankAccountHolderName" disabled/>
                     <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />

                            </span>
      
          </p>
          </b-field>
      </div>
    </div>
    </div>

    
  <div v-if="$root.formData.account !==`Minor Savings`">
    <hr>
    <div class="columns">
        <div class="column is-11 has-text-weight-bold"> 
          {{$root.selectedLanguageData.do_you_need_to_appoint_nominees}}<span class="has-text-danger"> *</span> 
        </div>

        <div class="column">
          <b-switch   
          disabled    
          :true-value="true"
                          :false-value="false"
                          v-model="$root.formData.isAgreeToNominees"
                          size="is-small"
                          ></b-switch>

        </div>

      </div>

  <div v-if="$root.formData.nomineesData[0].name !== ''">
      <NomineesInfo :nomineeIndex="0" :isDisabled="true"/>
      </div>
      <div v-if="$root.formData.nomineesData[1].name !== ''">
       <NomineesInfo :nomineeIndex="1" :isDisabled="true"/>
      </div>
       <div v-if="$root.formData.nomineesData[2].name !== ''">
       <NomineesInfo :nomineeIndex="2" :isDisabled="true"/>
      </div>

  </div>


<!--                if account type is kekulu this section will display-->
                <div class="mt-4 columns" v-if="$root.formData.childrenAccountOpeningPurpose !== ''">
                  <div class="column is-three-quarters">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.forWhomCreateAccount
                      }}
                    </label>

                    <div>
                      <b-input  disabled style="width: 100%" v-model="$root.formData.childrenAccountOpeningPurpose">
                      </b-input>
                    </div>


                  </div>
                </div>






                <!-- Account type and account end here -->
                <div v-if="$root.formData.account !== `Minor Savings` && $root.formData.haveNic === 'Yes'">
                  <hr style="background-color: #1b1b1b; height: 1.7px">
                <p class="preview-page-title">Personal Information </p>

                <!-- full Name with title -->
                <div class="mt-3">
                  <div class="columns">
                    <div
                        class="column is-one-fifths"

                    >
                      <label
                          :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                      >
                        {{ $root.selectedLanguageData.title
                        }}</label
                      >
                      <b-field>
                        <div>
                          <b-select v-model="$root.formData.title" disabled>
                            <option value="Mr">
                              {{ $root.selectedLanguageData.mr }}
                            </option>
                            <option value="Mrs">
                              {{ $root.selectedLanguageData.mrs }}
                            </option>
                            <option value="Miss">
                              {{ $root.selectedLanguageData.miss }}
                            </option>
                            <option value="Rev">
                              {{ $root.selectedLanguageData.rev }}
                            </option>
                            <option value="Professor">
                              {{ $root.selectedLanguageData.professor }}
                            </option>
                            <option value="Dr">
                              {{ $root.selectedLanguageData.dr }}
                            </option>
                            <option value="Master" >
                              {{ $root.selectedLanguageData.master }}
                            </option>
                            <option value="Ms">
                              {{ $root.selectedLanguageData.ms }}
                            </option>
                          </b-select>
                        </div>
                      </b-field>
                    </div>

                    <!--                    v-if="$root.kycFieldVisibility.surname"-->
                    <div
                        class="column is-four-fifths"

                    >
                      <label
                          :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                      >{{ $root.selectedLanguageData.surname }}
                      </label
                      >
                      <div class="field">
                        <p class="control has-icons-right">
                          <b-input
                              disabled
                              type="text"
                              v-model="$root.formData.surname"
                          />
                          <span class="icon is-small is-right">
                        <img
                            src="../assets/images/icons/Blue/Group 158.png"
                            alt="contact-name-img"
                            width="25"
                            height="25"
                        />
                      </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!--    other name-->
                <div class="mt-4" >
                  <label
                      :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                  >{{ $root.selectedLanguageData.otherName }}
                  </label
                  >
                  <b-field>
                    <b-input
                        type="text"
                        disabled
                        v-model="$root.formData.other_name"
                    />
                  </b-field>
                </div>

                <!-- Gender start-->
                <div class="field mt-4 is-flex is-justify-content-space-between ">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.gender}}

                    </label>

                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.gender == 'Male'">
                        <b-field>
                          <b-radio name="gender" style="font-family: OpenSans-Regular" v-model="$root.formData.gender" disabled native-value="Male">
                            {{$root.selectedLanguageData.male }}
                          </b-radio>

                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.gender == 'Female'">
                        <b-field>
                          <b-radio name="gender" style="font-family: OpenSans-Regular" native-value="Female"
                                   v-model="$root.formData.gender" disabled >
                            {{ $root.selectedLanguageData.female }}
                          </b-radio>
                        </b-field>
                      </div>

                      <!--                      <div class="column is-one-two">-->
                      <!--                        <b-field>-->
                      <!--                          <b-radio name="gender" style="font-family: fira400" native-value="Other"-->
                      <!--                                   v-model="$root.formData.gender">-->
                      <!--                            {{ $root.selectedLanguageData.other }}-->
                      <!--                          </b-radio>-->
                      <!--                        </b-field>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                </div>
                <!-- Gender  end-->

                <!-- Marital status start-->
                <div class="field mt-4 is-flex is-justify-content-space-between ">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.maritalStatus}}

                    </label>

                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.marital_status == 'Married'">
                        <b-field>
                          <b-radio name="Married" style="font-family: OpenSans-Regular" native-value="Married" disabled
                                   v-model="$root.formData.marital_status">
                            {{$root.selectedLanguageData.married }}
                          </b-radio>
                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.marital_status == 'Unmarried'">
                        <b-field>
                          <b-radio name="Unmarried" style="font-family: OpenSans-Regular" native-value="Unmarried" disabled
                                   v-model="$root.formData.marital_status" >
                            {{ $root.selectedLanguageData.unmarried }}
                          </b-radio>
                        </b-field>
                      </div>

                      <div class="column is-one-two" v-if="$root.formData.marital_status == 'Other'">
                        <b-field>
                          <b-radio name="gender" style="font-family: OpenSans-Regular" native-value="Other" disabled
                                   v-model="$root.formData.marital_status">
                            {{ $root.selectedLanguageData.other }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Marital status end-->

                <!-- Spouse name start-->
                <div class="is-one-two"  v-if="$root.formData.marital_status === `Married`">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.spouse_name }}</label>

                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.spouse_name"
                    />
                  </b-field>
                </div>
                <!--                  Spouse name end-->

                <!-- residence select start -->
                <div class="field mt-5  ">
                  <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.residency}}</label>
                  <div class="columns">
                    <div class="column is-one-two" v-if="$root.formData.residentship == 'Resident in Sri Lanka'">
                      <b-field>
                        <b-radio name="residence" style="font-family: OpenSans-Regular"
                                 disabled
                                 native-value="Resident in Sri Lanka"
                                 v-model="$root.formData.residentship">
                          {{$root.selectedLanguageData.residentInSriLanka }}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-one-two" v-if="$root.formData.residentship == 'Non Resident'">
                      <b-field>
                        <b-radio name="residence" style="font-family: OpenSans-Regular"
                                 disabled
                                 native-value="Non Resident"
                                 v-model="$root.formData.residentship">
                          {{ $root.selectedLanguageData.nonResident }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>
                <!-- residence select end-->

<!--                if residence is out of Sri Lanka start-->
                <div class="columns mt-4" v-if="$root.formData.residentship ===`Non Resident` ">
                  <div class="column">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.specifyTheCountry}}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">
                        <b-input disabled type="text" v-model="$root.formData.resident_country" />
                      </p>
                    </b-field>
                  </div>
                </div>
                <!--                if residence is out of Sri Lanka end-->


                <!--  nationality country-->
                <div>
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.nationalityCitizenship }}

                  </label>
                  <b-field>
                    <b-input disabled type="text" v-model="$root.formData.citizenship" />
                  </b-field>
                </div>


                <!--                if nationality is out of Sri Lanka start-->
                <div class="columns mt-4" v-if="$root.formData.citizenship === 'Sri Lankan with Dual Citizenship'">
                  <div class="column">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.specifyTheCountry}}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">
                        <b-input disabled type="text" v-model="$root.formData.citizenship_country" />
                      </p>
                    </b-field>
                  </div>
                </div>
                <!--                if nationality is out of Sri Lanka end-->

                <!--nic number & driving licence-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.nic_number}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input disabled type="text" v-model="$root.formData.customer_nic" />
                          <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two" v-if="$root.formData.account_holder_driving_licence !==''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.driving_licence}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input disabled type="text" v-model="$root.formData.account_holder_driving_licence" />
                          <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
                <div class="columns mt-4" v-if="$root.formData.account_holder_passport_number !== ''">
                  <div class="column">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.passport_no}}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">
                        <b-input disabled type="text" v-model="$root.formData.account_holder_passport_number" />
                      </p>
                    </b-field>
                  </div>
                </div>

                <!--              passport issue and expire date section start here-->
                <div class="columns mt-4">
                  <div class="column" v-if="$root.formData.account_holder_passport_issue_date !== ''">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.passport_issued_date}}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">

                        <b-datepicker
                            disabled
                            class="date-picking"
                            icon-right="calendar-today"
                            v-model="$root.formData.account_holder_passport_issue_date"
                            :max-date="maxDate"
                        >
                        </b-datepicker>


                      </p>
                    </b-field>
                  </div>

                  <div class="column" v-if="$root.formData.account_holder_passport_expiry_date !== ''">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.passport_expiry_date}}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">
                        <b-datepicker
                            class="date-picking"
                            icon-right="calendar-today"
                            v-model="$root.formData.account_holder_passport_expiry_date"
                            :max-date="maxDate"
                            disabled
                        >
                        </b-datepicker>
                      </p>
                    </b-field>
                  </div>
                </div>
                <!--              passport issue and expire date section end here-->
                <hr>
                <!-- address -->
                <div class="mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.permanentAddress }}
                  </label>
                  <!--permanent address house name-->
                  <div class="mt-1">
                    <p>
                      {{ $root.selectedLanguageData.houseName }}

                    </p>
                    <b-field>

                      <p class="control has-icons-right">
                        <b-input disabled type="text"
                                 v-model="$root.formData.permanent_address_line1"></b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                      </p>


                    </b-field>
                  </div>

                  <div class="columns is-7 is-variable mt-2">
                    <!--permanent address street name-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.streetName }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.permanent_address_line2"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>

                      </b-field>
                    </div>
                    <!--permanent address city-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.city }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.permanent_address_line3"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>


                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-7 is-variable">
                    <!--permanent address postal code-->
                    <div class="column">
                      <p>{{ $root.selectedLanguageData.postalCode }}</p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.permanent_address_postal_code">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                      </b-field>
                    </div>
                    <!--permanent address country-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.country }}

                      </p>
                      <div>
                        <div style="width: 100%">
                          <b-select disabled v-model="$root.formData.permanent_address_country" expanded>
                            <option v-for="country in $root.selectedLanguageData.countries"
                                    :key="country.value"
                                    :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                    {{ $root.selectedLanguageData.mailingAddress }}</label>
                  <b-field>
                    <b-checkbox type="is-primary"
                                v-model="$root.formData.mailing_address_same_as_permanent_address"
                                disabled>
                      {{$root.selectedLanguageData.sameAsPermanentAddress }}
                    </b-checkbox>
                  </b-field>

                  <!--mailing address house name-->
                  <div class="mt-1">
                    <p>
                      {{ $root.selectedLanguageData.houseName }}

                    </p>
                    <b-field>
                      <p class="control has-icons-right">
                        <b-input type="text"
                                 v-model="$root.formData.mailing_address_line1"
                                 disabled>
                        </b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>

                    </b-field>
                  </div>

                  <div class="columns is-7 is-variable mt-2">
                    <!--mailing address street name-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.streetName }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.mailing_address_line2"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>

                      </b-field>
                    </div>
                    <!--mailing address city-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.city }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text" v-model="$root.formData.mailing_address_line3"
                                   disabled></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>

                      </b-field>
                    </div>
                  </div>
                  <div class="columns is-7 is-variable">
                    <!--mailing postal code-->
                    <div class="column">
                      <p>{{ $root.selectedLanguageData.postalCode }}</p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.mailing_address_postal_code"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                      </b-field>
                    </div>

                    <!--mailing address country-->
                    <div class="column">
                      <p>
                        {{ $root.selectedLanguageData.country }}

                      </p>
                      <div>
                        <div style="width: 100%">
                          <b-select
                              v-model="$root.formData.mailing_address_country"
                              disabled expanded>
                            <option v-for="country in $root.selectedLanguageData.countries"
                                    :key="country.value"
                                    :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--residence contact number start here -->
                <div v-if="$root.formData.residentNumber !==''">
                <div class=" mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`"><span class="has-text-info">{{ $root.selectedLanguageData.contactNumberResident
                    }}</span></label>

                  <div class="columns is-7 is-variable">
                    <div class="column is-3">
                      <div>
                        <section>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-autocomplete  maxlength="10" icon-pack="fi" v-model ="$root.formData.residenceCountryCode" :icon="$root.formData.countryIconStringResidance" disabled>
                              </b-autocomplete>
                              <span class="icon is-small is-right mr-2">
                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />
                            </span>

                            </p>
                          </b-field>
                        </section>

                      </div>
                    </div>
                    <div class="column is-5">
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input v-model="$root.formData.residanceContactNumWithOutCode" type="tel" disabled/>
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

<!--                          <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed-->
<!--                            to start with 0</span>-->

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
              </div>
                <!--residence contact number end here -->

                <!--office contact number start here -->
                <div v-if="$root.formData.officeNumber !==''">
                <div class=" mt-4">
                  <label :class=" `${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`"><span class="has-text-info">{{ $root.selectedLanguageData.contactNumberOffice
                    }}</span></label>

                  <div class="columns is-7 is-variable">
                    <div class="column is-3">
                      <div>
                        <section>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-autocomplete  maxlength="10" icon-pack="fi" v-model="$root.formData.officeCountryCode" :icon="$root.formData.countryIconStringOffice" disabled>
                              </b-autocomplete>
                              <span class="icon is-small is-right mr-2">
                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />
                            </span>
                            </p>
                          </b-field>
                        </section>

                      </div>
                    </div>
                    <div class="column is-5">
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input v-model="$root.formData.officeContactNumWithOutCode" type="tel" disabled/>
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

<!--                          <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed-->
<!--                            to start with 0</span>-->

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
                </div>
                <!--office contact number end here -->

                <hr>

                <!--us person-->
                <div class="field mt-4 is-flex is-justify-content-space-between ">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.areYouaUSPerson}}

                    </label>

                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.us_person == 'Yes'">
                        <b-field>
                          <b-radio name="Yes" style="font-family: OpenSans-Regular" disabled
                                   v-model="$root.formData.us_person"
                                   native-value="Yes">
                            {{$root.selectedLanguageData.yes }}
                          </b-radio>
                        </b-field>
                      </div>
                      <div class="column is-one-two"  v-if="$root.formData.us_person == 'No'">
                        <b-field>
                          <b-radio name="No" native-value="No" style="font-family: OpenSans-Regular" disabled
                                   v-model="$root.formData.us_person">
                            {{ $root.selectedLanguageData.no}}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- are you us person end-->

                <!--  if person in US this will show-->
                <div  v-if="$root.formData.us_person === `Yes`">
                  <div class="columns">
                    <div class="column is-half">
                      <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.account_number_in_nsb
                        }}
                      </label>
                      <b-field>
                        <b-input disabled @focus="$inputFocused('us_person_account_numbers')"
                                 @input="$inputChanged('us_person_account_numbers')"
                                 @blur="$inputBlured('us_person_account_numbers')"
                                 v-model="$root.formData.us_person_account_numbers"
                        />

                      </b-field>

                    </div>
                    <div class="column is-half">
                      <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.place_of_birth
                        }}
                      </label>
                      <div class="field">
                        <p class="control has-icons-right">

                          <b-input disabled @focus="$inputFocused('us_person_place_of_birth')"
                                   @input="$inputChanged('us_person_place_of_birth')"
                                   @blur="$inputBlured('us_person_place_of_birth')"
                                   v-model="$root.formData.us_person_place_of_birth"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="location-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- address -->
                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.permanentAddress }}
                    </label>
                    <!--permanent address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.us_person_permanent_address_line1"></b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                        </p>


                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--permanent address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.us_person_permanent_address_line2"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--permanent address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.us_person_permanent_address_line3"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>


                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--permanent address postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.us_person_permanent_address_postal_code">
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--permanent address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-select disabled v-model="$root.formData.us_person_permanent_address_country" expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                      {{ $root.selectedLanguageData.mailingAddress }}</label>
                    <b-field>
                      <b-checkbox type="is-primary"
                                  v-model="$root.formData.mailing_address_in_us_same_as_permanent_address_in_us"
                                  disabled>
                        {{$root.selectedLanguageData.sameAsPermanentAddress }}
                      </b-checkbox>
                    </b-field>

                    <!--mailing address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.us_person_mailing_address_line1"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>

                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--mailing address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.us_person_mailing_address_line2"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--mailing address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text" v-model="$root.formData.us_person_mailing_address_line3"
                                     disabled></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--mailing postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.us_person_mailing_address_postal_code"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--mailing address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>

                          <div style="width: 100%">
                            <b-select
                                v-model="$root.formData.us_person_mailing_address_country"
                                disabled expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- us person passport-->
                  <div class="mt-4" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.passportNo }}
                    </label
                    >
                    <b-field>
                      <b-input
                          @focus="$inputFocused('us_person_passport_no')"
                          @input="$inputChanged('us_person_passport_no')"
                          @blur="$inputBlured('us_person_passport_no')"
                          type="text"
                          disabled
                          v-model="$root.formData.us_person_passport_no"
                      />
                    </b-field>
                  </div>

                  <!--us contact number start here -->
                  <div class=" mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.us_telephone_number
                      }}</label>

                    <div class="columns is-7 is-variable">
                      <div class="column is-2">
                        <div>
                          <section>
                            <b-field>
                              <p class="control has-icons-right">
                                <b-select @input="changeUsContactNumCountryCode()"
                                          v-model="$root.formData.usTellCountryCode" icon-pack="fi" :icon="iconStringUs" disabled>
                                  <option v-for="country in $root.formData
                                    .countriesList" :key="country.code" :value="country.code">
                                    {{ country.phone }}
                                  </option>
                                </b-select>
                                <span class="icon is-small is-right mr-2">
                            </span>

                              </p>
                            </b-field>

                          </section>

                        </div>
                      </div>
                      <div class="column is-5">
                        <b-field>
                          <p class="control has-icons-right">

                            <b-input type="tel" disabled  v-model="$root.formData.us_tel_number"
                                     @focus="$inputFocused('us_person_telephone_no')"
                                     @blur="$inputBlured('us_person_telephone_no')"/>
                            <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

                            <!-- <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed
                            to start with 0</span> -->

                          </p>
                        </b-field>
                      </div>
                    </div>
                  </div>
                  <!--us contact number end here -->

                  <!--us tax idintification number-->
                  <div class="mt-4" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.tax_identification_number_or_social_security_number }}
                    </label
                    >
                    <b-field>
                      <b-input
                          type="text"
                          @focus="$inputFocused('us_person_tax_identification_no')"
                          @input="$inputChanged('us_person_tax_identification_no')"
                          @blur="$inputBlured('us_person_tax_identification_no')"
                          disabled
                          v-model="$root.formData.us_person_tax_identification_no"
                      />
                    </b-field>
                  </div>

                </div>
                <!-- us section end here-->



                <!--tax payer section-->
                <div class="field mt-5  ">

                  <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">
                    {{ $root.selectedLanguageData.are_you_a_tax_payer}}

                  </label>
                  <div class="columns">
                    <div class="column is-one-two" v-if="$root.formData.tax_payer === 'Yes'">
                      <b-field>
                        <b-radio name="AreYouPayTax" style="font-family: OpenSans-Regular" native-value="Yes" disabled
                                 v-model="$root.formData.tax_payer">
                          {{$root.selectedLanguageData.yes }}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-one-two" v-if="$root.formData.tax_payer === 'No'">
                      <b-field>
                        <b-radio name="AreYouPayTax" style="font-family: OpenSans-Regular" native-value='No' disabled
                                 v-model="$root.formData.tax_payer">
                          {{ $root.selectedLanguageData.no }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>

                <div class="mt-4"  v-if="$root.formData.tax_payer ==`Yes`">
                  <label
                      :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                  >{{ $root.selectedLanguageData.enter_the_tax_file_number }}
                  </label
                  >
                  <b-field>
                    <div class="field">
                      <p class="control has-icons-right">
                        <b-input
                            type="text"
                            @focus="$inputFocused('tax_file_number')"
                            @input="$inputChanged('tax_file_number')"
                            @blur="$inputBlured('tax_file_number')"
                            disabled
                            v-model="$root.formData.tax_file_number"
                        />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                      </p>
                    </div>
                  </b-field>
                </div>


                <!-- is politicaly exposed-->
                <div class="field mt-5  ">

                  <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.publicPositionsHeldBySelf
                    }}</label>
                  <div class="columns">
                    <div class="column is-one-two" v-if="$root.formData.politically_exposed == 'Yes'">
                      <b-field>
                        <b-radio name="politically_exposed" style="font-family: OpenSans-Regular" native-value="Yes" disabled
                                 v-model="$root.formData.politically_exposed">
                          {{$root.selectedLanguageData.yes }}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-8" v-if="$root.formData.politically_exposed == 'No'">
                      <b-field>
                        <b-radio name="politically_exposed" style="font-family: OpenSans-Regular" native-value="No" disabled
                                 v-model="$root.formData.politically_exposed">
                          {{ $root.selectedLanguageData.no }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>

                <div class="mt-4" v-if="$root.formData.politically_exposed =='Yes' " >
                  <label
                      :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                  >{{ $root.selectedLanguageData.name }}
                  </label
                  >
                  <b-field>
                    <div class="field">
                      <p class="control has-icons-right">
                        <b-input
                            type="text"
                            @focus="$inputFocused('politically_exposed_position')"
                            @input="$inputChanged('politically_exposed_position')"
                            @blur="$inputBlured('politically_exposed_position')"
                            disabled
                            v-model="$root.formData.politically_exposed_position"
                        />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                      </p>
                    </div>
                  </b-field>
                </div>


                <!--If Pubic Positions Heldby CloserRelative Or Associate is yes then this field should be visible-->

                <div class="field mt-5  ">

                  <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.publicPositionsHeldbyCloserRelativeOrAssociate
                    }}</label>
                  <div class="columns">
                    <div class="column is-one-two" v-if="$root.formData.politically_exposed_relative == 'Yes'">
                      <b-field>
                        <b-radio name="PublicPositions" style="font-family: OpenSans-Regular" native-value="Yes" disabled
                                 v-model="$root.formData.politically_exposed_relative">
                          {{$root.selectedLanguageData.yes}}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-one-two" v-if="$root.formData.politically_exposed_relative == 'No'">
                      <b-field>
                        <b-radio name="PublicPositionsHeldBySelf" style="font-family: OpenSans-Regular" native-value="No" disabled
                                 v-model="$root.formData.politically_exposed_relative">
                          {{ $root.selectedLanguageData.no }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>
                </div>

                <div class="mt-4" v-if="$root.formData.politically_exposed_relative == 'Yes'" >
                  <label
                      :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                  >{{ $root.selectedLanguageData.name }}
                  </label>
                  <b-field>
                    <div class="field">
                      <p class="control has-icons-right">
                        <b-input
                            type="text"
                            @focus="$inputFocused('politically_exposed_relative_position')"
                            @input="$inputChanged('politically_exposed_relative_position')"
                            @blur="$inputBlured('politically_exposed_relative_position')"
                            disabled
                            v-model="$root.formData.politically_exposed_relative_position"
                        />
                        <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                      </p>
                    </div>
                  </b-field>
                </div>
                </div>


<!--                <div class="mt-4"  v-if="$root.formData.politically_exposed_relative == 'Yes'">-->
<!--                  <label-->
<!--                      :class="`${-->
<!--                      $root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                        ? `si-label`-->
<!--                        : ``-->
<!--                    }`"-->
<!--                  >{{ $root.selectedLanguageData.specify_the_designation }}-->
<!--                  </label>-->
<!--                  <b-field>-->
<!--                    <div class="field">-->
<!--                      <p class="control has-icons-right">-->
<!--                        <b-input-->
<!--                            type="text"-->
<!--                            @focus="$inputFocused('specified_designation')"-->
<!--                            @input="$inputChanged('specified_designation')"-->
<!--                            @blur="$inputBlured('specified_designation')"-->
<!--                            disabled-->
<!--                            v-model="$root.formData.specified_designation"-->
<!--                        />-->
<!--                        <span class="icon is-small is-right">-->
<!--                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />-->
<!--                        </span>-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </b-field>-->
<!--                </div>-->


                <!--if kekulu account-->
                <hr style="background-color: #1b1b1b; height: 1.7px">
                <!--&gt;>>>>>> 3735f05765c15fca27a6c56882916b67b25f2443-->

                <div v-if="$root.formData.account === `Minor Savings` || $root.formData.haveNic === 'No'">
                  <div>
                    <p class="preview-page-title">Account Holder's Information </p>
                  </div>

                  <!-- full Name with title -->
                  <div class="mt-3">
                    <div class="columns">
                      <div
                          class="column is-one-fifths"

                      >
                        <label
                            :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                        >
                          {{ $root.selectedLanguageData.title
                          }}</label
                        >
                        <b-field>
                          <div>
                            <b-select v-model="$root.formData.title" disabled>
                              <option value="Master">
                                {{ $root.selectedLanguageData.mr }}
                              </option>
                              <option value="Miss">
                                {{ $root.selectedLanguageData.miss }}
                              </option>

                            </b-select>
                          </div>
                        </b-field>
                      </div>

                      <!--                    v-if="$root.kycFieldVisibility.surname"-->
                      <div
                          class="column is-four-fifths"

                      >
                        <label
                            :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                        >{{ $root.selectedLanguageData.surname }}
                        </label
                        >
                        <div class="field">
                          <b-input
                              disabled
                              type="text"
                              v-model="$root.formData.surname"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- otherName -->
                  <!--                v-if="$root.kycFieldVisibility.other_name"-->
                  <div class="mt-4" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.otherName }}
                    </label
                    >
                    <b-field>
                      <b-input
                          type="text"
                          disabled
                          v-model="$root.formData.other_name"
                      />
                    </b-field>
                  </div>

                  <!-- Gender start-->
                  <div class="field mt-4 is-flex is-justify-content-space-between ">
                    <div>
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.gender}}

                      </label>

                      <div class="columns">
                        <div class="column is-one-two" >
                          <b-field>
                            <b-radio name="genderAccountHolder" style="font-family: OpenSans-Regular"
                                     native-value="Male"
                                     disabled
                                     v-model="$root.formData.gender">
                              {{$root.selectedLanguageData.male }}
                            </b-radio>
                          </b-field>
                        </div>
                        <div class="column is-one-two" >
                          <b-field>
                            <b-radio name="genderAccountHolder" style="font-family: OpenSans-Regular" native-value="Female"
                                     disabled
                                     v-model="$root.formData.gender">
                              {{ $root.selectedLanguageData.female }}
                            </b-radio>
                          </b-field>
                        </div>
                      </div>
                    </div>

                  </div>
                  <!-- Gender  end-->

<!--                  <div>-->
<!--                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                      {{ $root.selectedLanguageData.dateofBirth}}-->
<!--                    </label>-->
<!--                    <b-field>-->
<!--                      <p class="control has-icons-right">-->
<!--                          <b-datepicker-->
<!--                              disabled-->
<!--                              class="date-picking"-->
<!--                              icon-right="calendar-today"-->
<!--                              v-model="$root.formData.account_holder_dob"-->
<!--                          >-->
<!--                          </b-datepicker>-->
<!--                          <span class="has-text-danger">{{ errors[0] }}</span>-->

<!--                      </p>-->
<!--                    </b-field>-->
<!--                  </div>-->

                  <!--              occupation start here-->

                  <div >
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                      {{ $root.selectedLanguageData.occupation }}

                    </label>

                    <div>
<!--                      <b-select disabled-->
<!--                                v-model="$root.formData.employment_position" expanded>-->
<!--                        <option v-for="o in $root.selectedLanguageData.occupations" :value="o" :key="o">-->
<!--                          {{ o }}-->
<!--                        </option>-->
<!--                      </b-select>-->
                      <b-input type="text" disabled
                               v-model="$root.formData.occupation"/>
                    </div>

                  </div>
                  <!--              occupation end here-->


                  <!--school field start here-->
                  <!--                v-if="$root.formData.occupation === 'Student'"-->
                  <div class="mt-4"  v-if="$root.formData.occupation === 'Student'" >
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                      {{ $root.selectedLanguageData.school }}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">

                        <b-input type="text" disabled
                                 v-model="$root.formData.school"/>
                      </p>
                    </b-field>
                  </div>

                  <div class="mt-4"  v-if="$root.formData.occupation === 'Other'" >
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                      {{ $root.selectedLanguageData.specify_the_occupation }}

                    </label>
                    <b-field>
                      <p class="control has-icons-right">

                        <b-input type="text" disabled
                                 v-model="$root.formData.other_occupation"/>
                      </p>
                    </b-field>
                  </div>
                  <!--school field end here-->

                  <!--              year and grade fields start here-->
                  <!--                v-if="$root.formData.occupation === 'Student'"-->
                  <div class="columns mt-3" >
<!--                    <div class="column is-two-fifths">-->
<!--                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">-->
<!--                        {{ $root.selectedLanguageData.year }}-->

<!--                      </label>-->

<!--                      <b-input type="text" v-model="$root.formData.surname" disabled/>-->

<!--                    </div>-->
                    <div class="column is-two-fifths"  v-if="$root.formData.occupation === 'Student'">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.grade }}

                      </label>

                      <div>

<!--                        <b-select-->
<!--                            v-model="$root.formData.grade"-->
<!--                            expanded>-->
<!--                        </b-select>-->
                        <b-input type="text" disabled
                                 v-model="$root.formData.grade"/>
                      </div>
                    </div>
                  </div>
                  <!--              year and grade fields end here-->

                  <!--              residency section start-->
                  <div class="field mt-4">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.residency}}

                    </label>

                    <div class="columns">
                      <div class="column is-one-quarter" v-if="$root.formData.residentship === 'Resident in Sri Lanka'">
                        <b-field>

                          <b-radio disabled name="gender" style="font-family: OpenSans-Regular" native-value="Resident in Sri Lanka"
                                   v-model="$root.formData.residentship">
                            {{$root.selectedLanguageData.residentInSriLanka }}
                          </b-radio>

                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.residentship === 'Non Resident'">
                        <b-field>
                          <b-radio disabled name="gender" style="font-family: OpenSans-Regular" native-value="Non Resident"
                                   v-model="$root.formData.residentship">
                            {{ $root.selectedLanguageData.nonResident }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>
                  <!--                v-if=" $root.formData.account_holder_residentship === `Not resident in Sri Lanka` "-->
                  <div v-if=" $root.formData.residentship ===`Non Resident`">
                    <div>
                      <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                        {{
                          $root.selectedLanguageData
                              .specifyTheCountry
                        }}</label>

                      <div>

                        <div style="width: 100%">
                          <b-select disabled v-model="$root.formData.resident_country"
                                    expanded>
                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--              residency section end-->

                  <!-- Citizenship select start here -->
                  <div class="columns mt-4"> <!-- (v-if="$root.kycFieldVisibility.citizenship") need to add -->
                    <div class="column">
                      <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                        {{ $root.selectedLanguageData.nationalityCitizenship
                        }}</label>
                      <div style="width: 100%">

<!--                        <b-select disabled style="width: 100%" expanded v-model="$root.formData.citizenship">-->

<!--                        </b-select>-->
                        <b-input type="text" disabled
                                 v-model="$root.formData.citizenship"/>

                      </div>
                    </div>
                    <!-- Citizenship select end here -->

                    <div class="column" v-if="$root.formData.account_holder_passport_number !== ''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_no}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input disabled type="text" v-model="$root.formData.account_holder_passport_number" />
                          <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>
                        </p>
                      </b-field>
                    </div>
                  </div>
                  <!--              citizenship and passport number section end-->

                  <!--              passport issue and expire date section start here-->
                  <div class="columns mt-4">
                    <div class="column" v-if="$root.formData.account_holder_passport_issue_date !== ''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_issued_date}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-datepicker
                              disabled
                              class="date-picking"
                              icon-right="calendar-today"
                              v-model="$root.formData.account_holder_passport_issue_date"
                              :max-date="maxDate"
                          >
                          </b-datepicker>


                        </p>
                      </b-field>
                    </div>

                    <div class="column" v-if="$root.formData.account_holder_passport_expiry_date !== ''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_expiry_date}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-datepicker
                              class="date-picking"
                              icon-right="calendar-today"
                              v-model="$root.formData.account_holder_passport_expiry_date"
                              :max-date="maxDate"
                              disabled
                          >
                          </b-datepicker>
                        </p>
                      </b-field>
                    </div>
                  </div>

                  <!--              passport issue and expire date section end here-->
                  <hr>

                  <!-- address -->
                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.permanentAddress }}
                    </label>
                    <!--permanent address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.permanent_address_line1"></b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                        </p>


                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--permanent address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.permanent_address_line2"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--permanent address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.permanent_address_line3"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>


                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--permanent address postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.permanent_address_postal_code">
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--permanent address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-select disabled v-model="$root.formData.permanent_address_country" expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                      {{ $root.selectedLanguageData.mailingAddress }}</label>
                    <b-field>
                      <b-checkbox disabled type="is-primary"
                                  v-model="$root.formData.mailing_address_same_as_permanent_address"
                                 
                                  @change.native="mailingAddress()">
                        {{$root.selectedLanguageData.sameAsPermanentAddress }}
                      </b-checkbox>
                    </b-field>

                    <!--mailing address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.mailing_address_line1"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>

                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--mailing address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.mailing_address_line2"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--mailing address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text" v-model="$root.formData.mailing_address_line3"
                                     disabled></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--mailing postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.mailing_address_postal_code"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--mailing address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>

                          <div style="width: 100%">
                            <b-select
                                v-model="$root.formData.mailing_address_country"
                                disabled expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>

                            </b-select>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                  <hr style="background-color: #1b1b1b; height: 1.7px" />


                </div>

<!--                v-if="$root.formData.account_name === `Children's Account` "-->
                <div v-if="$root.formData.account === `Minor Savings`|| $root.formData.haveNic=== 'No'">
                  <p class="preview-page-title">Guardian's Information</p>

                  <!-- full Name with title -->
                  <div class="mt-3">
                    <div class="columns">
                      <div
                          class="column is-one-fifths"

                      >
                        <label
                            :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                        >
                          {{ $root.selectedLanguageData.title
                          }}</label
                        >
                        <b-field>
                          <div>
                            <b-select v-model="$root.formData.guardian_title" disabled>
                              <option v-for="title in $root.selectedLanguageData.titleList" :value="title.value" :key="title.value">
                                {{ title.langTranslation }}
                              </option>
                       

                            </b-select>
                          </div>
                        </b-field>
                      </div>

                      <!--                    v-if="$root.kycFieldVisibility.surname"-->
                      <div
                          class="column is-four-fifths"

                      >
                        <label
                            :class="`${
                          $root.selectedLanguage === `ta`
                            ? `ta-label`
                            : $root.selectedLanguage === `si`
                            ? `si-label`
                            : ``
                        }`"
                        >{{ $root.selectedLanguageData.surname }}
                        </label
                        >
                        <div class="field">
                          <b-input
                              disabled
                              type="text"
                              v-model="$root.formData.guardian_surname"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--                  Guardian's other name-->
                  <div class="mt-4" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.otherName }}
                    </label
                    >
                    <b-field>
                      <b-input
                          type="text"
                          disabled
                          v-model="$root.formData.guardian_other_name"
                      />
                    </b-field>
                  </div>


                  <!-- Gender start-->
                  <div class="field mt-4 is-flex is-justify-content-space-between ">
                    <div>
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.gender}}

                      </label>

                      <div class="columns">
                        <div class="column is-one-two" v-if="$root.formData.guardian_gender === 'Male'"
                        native-value = 'Male'>
                          <b-field>

                            <b-radio name="genderGuardian" style="font-family: OpenSans-Regular" v-model="$root.formData.guardian_gender" disabled native-value="Male">
                              {{$root.selectedLanguageData.male }}
                            </b-radio>

                          </b-field>
                        </div>
                        <div class="column is-one-two" v-if="$root.formData.guardian_gender === 'Female'">
                          <b-field>
                            <b-radio name="genderGuardian" style="font-family: OpenSans-Regular" native-value="Female"
                                     disabled
                                     v-model="$root.formData.guardian_gender">
                              {{ $root.selectedLanguageData.female }}
                            </b-radio>
                          </b-field>
                        </div>
                      </div>
                    </div>

                  </div>
                  <!-- Gender  end-->

                  <!-- Marital status start-->
                  <div class="field mt-4 is-flex is-justify-content-space-between ">
                    <div>
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.maritalStatus}}

                      </label>

                      <div class="columns">
                        <div class="column is-one-two" v-if="$root.formData.guardian_marital_status==='Married'">
                          <b-field>

                            <b-radio disabled name="guardianMarried" style="font-family: OpenSans-Regular"
                                     v-model="$root.formData.guardian_marital_status" native-value="Married">
                              {{$root.selectedLanguageData.married }}
                            </b-radio>

                          </b-field>
                        </div>
                        <div class="column is-one-two" v-if="$root.formData.guardian_marital_status === 'Unmarried'">
                          <b-field>
                            <b-radio disabled name="guardianMarried" style="font-family: OpenSans-Regular" v-model="$root.formData.guardian_marital_status" native-value="Unmarried">
                              {{ $root.selectedLanguageData.unmarried }}
                            </b-radio>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Marital status end-->


                  <!--                  Spouse name start-->
                  <div class="is-one-two" v-if="$root.formData.guardian_spouse_name !== ''">
                    <label
                        :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                    >{{ $root.selectedLanguageData.spouse_name
                      }}</label>
                    <b-field>
                      <b-input
                          disabled
                          type="email"
                          v-model="$root.formData.guardian_spouse_name"

                      />
                    </b-field>
                  </div>
                  <!--                  Spouse name end-->


                  <!--                  Relationship to the account holder start-->
                  <div class="mt-5 is-one-two">
                    <label
                        :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                    >{{ $root.selectedLanguageData.relationship_to_the_acc_holder
                      }}</label>
                    <b-field>
                      <b-input
                          disabled
                          type="email"
                          v-model="$root.formData.relationship_to_the_acc_holder"

                      />
                    </b-field>
                  </div>

                  <!--                  Relationship to the account holder end-->

                  <!-- residence select start -->
                  <div class="field mt-5  ">

                    <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.residency
                      }}</label>
                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.guardian_residency === 'Sri Lanka'">
                        <b-field>

                          <b-radio disabled name="residenceOne" style="font-family: OpenSans-Regular" native-value="Sri Lanka"
                                   v-model="$root.formData.guardian_residency"
                          >
                            {{
                              $root.selectedLanguageData.residentInSriLanka
                            }} </b-radio>

                        </b-field>
                      </div>
                      <div class="column is-8" v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">
                        <b-field>

                          <b-radio disabled name="residenceOne" style="font-family: OpenSans-Regular" native-value="Out of Sri Lanka"
                                   v-model="$root.formData.guardian_residency"
                          >
                            {{ $root.selectedLanguageData.nonResident }} </b-radio>

                        </b-field>
                      </div>
                    </div>
                  </div>
                  <!-- residence select end-->

                  <!--                  Guardian's nationality country-->
                  <div  v-if=" $root.formData.marital_status === `Married`">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.spouse_name }}

                    </label>
                    <b-field>
                      <ValidationProvider name="Name" v-slot="{ errors }">
                        <b-input type="text" v-model="$root.formData.spouse_name" />
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>

                  <!--nic number & driving licence-->
                  <div class="field mt-4">
                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.guardian_nic !== ''">
                        <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                          {{ $root.selectedLanguageData.nic_number}}

                        </label>
                        <b-field>
                          <p class="control has-icons-right">

                            <b-input disabled type="text" v-model="$root.formData.guardian_nic" />
                            <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                          </p>
                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.guardian_driving_licence !== ''">
                        <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                          {{ $root.selectedLanguageData.driving_licence}}

                        </label>
                        <b-field>
                          <p class="control has-icons-right">

                            <b-input disabled type="text" v-model="$root.formData.guardian_driving_licence" />
                            <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                          </p>
                        </b-field>
                      </div>
                    </div>
                  </div>

                  <div class="columns mt-4">
                    <div class="column" v-if="$root.formData.account_holder_passport_number">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_no}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.account_holder_passport_number" />
                        </p>
                      </b-field>
                    </div>

                  </div>




                  <!--              passport issue and expire date section start here-->
                  <div class="columns mt-4">
                    <div class="column" v-if="$root.formData.guardian_passport_issue_date !== ''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_issued_date}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-datepicker
                              disabled
                              class="date-picking"
                              icon-right="calendar-today"
                              v-model="$root.formData.guardian_passport_issue_date"
                              :max-date="maxDate"
                          >
                          </b-datepicker>


                        </p>
                      </b-field>
                    </div>

                    <div class="column" v-if="$root.formData.guardian_passport_expiry_date !== ''">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.passport_expiry_date}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-datepicker
                              class="date-picking"
                              icon-right="calendar-today"
                              v-model="$root.formData.guardian_passport_expiry_date"
                              :max-date="maxDate"
                              disabled
                          >
                          </b-datepicker>
                        </p>
                      </b-field>
                    </div>
                  </div>
                  <!--              passport issue and expire date section end here-->

<!--                  guardian permenent address -->
                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.guardian_permanent_address }}
                    </label>
                    <!--permanent address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.guardian_house_name"></b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                        </p>


                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--permanent address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.guardian_street_name"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--permanent address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.guardian_city"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>


                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--permanent address postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.guardian_postal_code">
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--permanent address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-input disabled v-model="$root.formData.guardian_country" expanded>
                              <!-- <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option> -->
                            </b-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

<!--                  guardian mailing address-->
                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                      {{ $root.selectedLanguageData.guardian_mailing_address }}</label>
                    <b-field>
                      <b-checkbox type="is-primary"
                                  v-model="$root.formData.guardian_mailing_address_different"
                                  disabled>
                        {{$root.selectedLanguageData.sameAsPermanentAddress }}
                      </b-checkbox>
                    </b-field>

                    <!--mailing address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.guardian_mailing_house_name"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>

                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--mailing address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.guardian_mailing_street_name"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--mailing address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text" v-model="$root.formData.guardian_mailing_city"
                                     disabled></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--mailing postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.guardian_mailing_postal_code"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>

                      <!--mailing address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-input
                                v-model="$root.formData.guardian_mailing_country"
                                disabled expanded>
                              <!-- <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option> -->
                            </b-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--residence contact number start here -->
                <div v-if="$root.formData.guardianResidentNumber !==''">
                <div class=" mt-4">
                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`"><span class="has-text-info">{{ $root.selectedLanguageData.contactNumberResident
                    }}</span></label>

                  <div class="columns is-7 is-variable">
                    <div class="column is-3">
                      <div>
                        <section>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-autocomplete  maxlength="10" icon-pack="fi" v-model ="$root.formData.guardianResidenceCountryCode" :icon="$root.formData.guardianCountryIconStringResidance" disabled>
                              </b-autocomplete>
                              <span class="icon is-small is-right mr-2">
                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />
                            </span>

                            </p>
                          </b-field>
                        </section>

                      </div>
                    </div>
                    <div class="column is-5">
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input v-model="$root.formData.guardianResidanceContactNumWithOutCode" type="tel" disabled/>
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

<!--                          <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed-->
<!--                            to start with 0</span>-->

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
              </div>
                <!--residence contact number end here -->

                <!--office contact number start here -->
                <div v-if="$root.formData.guardianOfficeContactNumWithOutCode !==''">
                <div class=" mt-4">
                  <label :class=" `${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`"><span class="has-text-info">{{ $root.selectedLanguageData.contactNumberOffice
                    }}</span></label>

                  <div class="columns is-7 is-variable">
                    <div class="column is-3">
                      <div>
                        <section>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-autocomplete  maxlength="10" icon-pack="fi" v-model="$root.formData.guardianOfficeCountryCode" :icon="$root.formData.guardianCountryIconStringOffice" disabled>
                              </b-autocomplete>
                              <span class="icon is-small is-right mr-2">
                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />
                            </span>
                            </p>
                          </b-field>
                        </section>

                      </div>
                    </div>
                    <div class="column is-5">
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input v-model="$root.formData.guardianOfficeContactNumWithOutCode" type="tel" disabled/>
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

<!--                          <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed-->
<!--                            to start with 0</span>-->

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
                </div>
                <!--office contact number end here -->

                  <!--us person-->
                  <div class="field mt-4 is-flex is-justify-content-space-between ">
                    <div>
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.areYouaUSPerson}}

                      </label>

                      <div class="columns">
                        <div class="column is-one-two" v-if="$root.formData.guardian_us_person == true">
                          <b-field>
                            <b-radio name="guardianUsPerson" style="font-family: OpenSans-Regular" disabled
                                     v-model="$root.formData.guardian_us_person"
                                     :native-value="true">
                              {{$root.selectedLanguageData.yes }}
                            </b-radio>
                          </b-field>
                        </div>
                        <div class="column is-one-two"  v-if="$root.formData.guardian_us_person == false">
                          <b-field>
                            <b-radio name="guardianUsPerson" :native-value="false" style="font-family: OpenSans-Regular" disabled
                                     v-model="$root.formData.guardian_us_person">
                              {{ $root.selectedLanguageData.no}}
                            </b-radio>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- are you us person end-->

                  <!--  if person in US this will show-->
                  <div  v-if="$root.formData.guardian_us_person == true">
                    <div class="columns">
                      <div class="column is-half">
                        <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.account_number_in_nsb
                          }}
                        </label>
                        <b-field>
                          <b-input disabled @focus="$inputFocused('guardian_acc_num')"
                                   @input="$inputChanged('guardian_acc_num')"
                                   @blur="$inputBlured('guardian_acc_num')"
                                   v-model="$root.formData.guardian_acc_num"
                          />

                        </b-field>

                      </div>
                      <div class="column is-half">
                        <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.place_of_birth
                          }}
                        </label>
                        <div class="field">
                          <p class="control has-icons-right">

                            <b-input disabled @focus="$inputFocused('guardian_place_of_birth')"
                                     @input="$inputChanged('guardian_place_of_birth')"
                                     @blur="$inputBlured('guardian_place_of_birth')"
                                     v-model="$root.formData.guardian_place_of_birth"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="location-img" width="25"
                                   height="25" />
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- address -->
                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.permanentAddress }}
                      </label>
                      <!--permanent address house name-->
                      <div class="mt-1">
                        <p>
                          {{ $root.selectedLanguageData.houseName }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.guardian_us_house_name"></b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                          </p>


                        </b-field>
                      </div>

                      <div class="columns is-7 is-variable mt-2">
                        <!--permanent address street name-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.streetName }}

                          </p>
                          <b-field>

                            <p class="control has-icons-right">
                              <b-input disabled type="text"
                                       v-model="$root.formData.guardian_us_street_name"></b-input>
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                            </p>

                          </b-field>
                        </div>
                        <!--permanent address city-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.city }}

                          </p>
                          <b-field>

                            <p class="control has-icons-right">
                              <b-input disabled type="text"
                                       v-model="$root.formData.guardian_us_city"></b-input>
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                            </p>


                          </b-field>
                        </div>
                      </div>
                      <div class="columns is-7 is-variable">
                        <!--permanent address postal code-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.postalCode }}</p>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-input disabled type="text"
                                       v-model="$root.formData.guardian_us_postal_code">
                              </b-input>
                              <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                            </p>
                          </b-field>
                        </div>
                        <!--permanent address country-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.country }}

                          </p>
                          <div>
                            <div style="width: 100%">
                              <b-select disabled v-model="$root.formData.guardian_us_country" expanded>
                                <option v-for="country in $root.selectedLanguageData.countries"
                                        :key="country.value"
                                        :value="country.value">
                                  {{ country.countryName }}
                                </option>
                              </b-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                        {{ $root.selectedLanguageData.mailingAddress }}</label>
                      <b-field>
                        <b-checkbox type="is-primary"
                                    v-model="$root.formData.guardian_us_mailing_address_different"
                                    disabled>
                          {{$root.selectedLanguageData.sameAsPermanentAddress }}
                        </b-checkbox>
                      </b-field>

                      <!--mailing address house name-->
                      <div class="mt-1">
                        <p>
                          {{ $root.selectedLanguageData.houseName }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.guardian_us_mailing_house_name"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>

                        </b-field>
                      </div>

                      <div class="columns is-7 is-variable mt-2">
                        <!--mailing address street name-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.streetName }}

                          </p>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-input type="text"
                                       v-model="$root.formData.guardian_us_mailing_street_name"
                                       disabled>
                              </b-input>
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                            </p>

                          </b-field>
                        </div>
                        <!--mailing address city-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.city }}

                          </p>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-input type="text" v-model="$root.formData.guardian_us_mailing_city"
                                       disabled></b-input>
                              <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                            </p>

                          </b-field>
                        </div>
                      </div>
                      <div class="columns is-7 is-variable">
                        <!--mailing postal code-->
                        <div class="column">
                          <p>{{ $root.selectedLanguageData.postalCode }}</p>
                          <b-field>
                            <p class="control has-icons-right">
                              <b-input type="text"
                                       v-model="$root.formData.guardian_us_mailing_postal_code"
                                       disabled>
                              </b-input>
                              <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                            </p>
                          </b-field>
                        </div>
                        <!--mailing address country-->
                        <div class="column">
                          <p>
                            {{ $root.selectedLanguageData.country }}

                          </p>
                          <div>

                            <div style="width: 100%">
                              <b-select
                                  v-model="$root.formData.guardian_us_mailing_country"
                                  disabled expanded>
                                <option v-for="country in $root.selectedLanguageData.countries"
                                        :key="country.value"
                                        :value="country.value">
                                  {{ country.countryName }}
                                </option>
                              </b-select>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- us person passport-->
                    <div class="mt-4" >
                      <label
                          :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                      >{{ $root.selectedLanguageData.passportNo }}
                      </label
                      >
                      <b-field>
                        <b-input
                            @focus="$inputFocused('guardian_us_passport')"
                            @input="$inputChanged('guardian_us_passport')"
                            @blur="$inputBlured('guardian_us_passport')"
                            type="text"
                            disabled
                            v-model="$root.formData.guardian_us_passport"
                        />
                      </b-field>
                    </div>

                    <!--us contact number start here -->
                    <div class=" mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.us_telephone_number
                        }}</label>

                      <div class="columns is-7 is-variable">
                        <div class="column is-2">
                          <div>
                            <section>
                              <b-field>
                                <p class="control has-icons-right">
                                  <b-select @input="changeGuardianUsContactNumCountryCode()"
                                            v-model="$root.formData.guardianUsTellCountryCode" icon-pack="fi" :icon="iconStringUsGuardian" disabled>
                                    <option v-for="country in $root.formData
                                    .countriesList" :key="country.code" :value="country.code">
                                      {{ country.phone }}
                                    </option>
                                  </b-select>
                                  <span class="icon is-small is-right mr-2">
                            </span>

                                </p>
                              </b-field>

                            </section>

                          </div>
                        </div>
                        <div class="column is-5">
                          <b-field>
                            <p class="control has-icons-right">

                              <b-input type="tel" disabled  v-model="$root.formData.guardian_us_tel_number"
                                       @focus="$inputFocused('guardian_us_tel_number')"
                                       @blur="$inputBlured('guardian_us_tel_number'); calGuardianUsContactNumber()" />
                              <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>

                              <!-- <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed
                              to start with 0</span> -->

                            </p>
                          </b-field>
                        </div>
                      </div>
                    </div>
                    <!--us contact number end here -->

                    <!--us tax idintification number-->
                    <div class="mt-4" >
                      <label
                          :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                      >{{ $root.selectedLanguageData.tax_identification_number_or_social_security_number }}
                      </label
                      >
                      <b-field>
                        <b-input
                            type="text"
                            @focus="$inputFocused('guardian_tax_idetification_number')"
                            @input="$inputChanged('guardian_tax_idetification_number')"
                            @blur="$inputBlured('guardian_tax_idetification_number')"
                            disabled
                            v-model="$root.formData.guardian_tax_idetification_number"
                        />
                      </b-field>
                    </div>

                  </div>
                  <!-- us section end here-->

                  <!-- guardian tax payer section-->
                  <div class="field mt-5  ">

                    <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">
                      {{ $root.selectedLanguageData.are_you_a_tax_payer}}

                    </label>
                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.guardian_are_you_a_tax_payer == true">
                        <b-field>
                          <b-radio name="are_you_a_tax_payer" style="font-family: OpenSans-Regular" :native-value="true" disabled
                                   v-model="$root.formData.guardian_are_you_a_tax_payer">
                            {{$root.selectedLanguageData.yes }}
                          </b-radio>
                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.guardian_are_you_a_tax_payer == false">
                        <b-field>
                          <b-radio name="are_you_a_tax_payer" style="font-family: OpenSans-Regular" :native-value="false" disabled
                                   v-model="$root.formData.guardian_are_you_a_tax_payer">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4"  v-if="$root.formData.guardian_are_you_a_tax_payer ==true">
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.enter_the_tax_file_number }}
                    </label
                    >
                    <b-field>
                      <div class="field">
                        <p class="control has-icons-right">
                          <b-input
                              type="text"
                              @focus="$inputFocused('guardian_tax_file_number')"
                              @input="$inputChanged('guardian_tax_file_number')"
                              @blur="$inputBlured('guardian_tax_file_numberr')"
                              disabled
                              v-model="$root.formData.guardian_tax_file_number"
                          />
                          <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        </p>
                      </div>
                    </b-field>
                  </div>

                  <!-- is politicaly exposed-->
                  <div class="field mt-5  ">

                    <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.publicPositionsHeldBySelf
                      }}</label>
                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.guardian_political_exposed == true">
                        <b-field>
                          <b-radio name="politicallyExposedUS" style="font-family: OpenSans-Regular" :native-value="true" disabled
                                   v-model="$root.formData.guardian_political_exposed">
                            {{$root.selectedLanguageData.yes }}
                          </b-radio>
                        </b-field>
                      </div>
                      <div class="column is-8" v-if="$root.formData.guardian_political_exposed == false">
                        <b-field>
                          <b-radio name="politicallyExposedUS" style="font-family: OpenSans-Regular" :native-value="false" disabled
                                   v-model="$root.formData.guardian_political_exposed">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4" v-if="$root.formData.guardian_political_exposed == true" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.then_specify_position }}
                    </label
                    >
                    <b-field>
                      <div class="field">
                        <p class="control has-icons-right">
                          <b-input
                              type="text"
                              @focus="$inputFocused('guardian_political_exposed_position')"
                              @input="$inputChanged('guardian_political_exposed_position')"
                              @blur="$inputBlured('guardian_political_exposed_position')"
                              disabled
                              v-model="$root.formData.guardian_political_exposed_position"
                          />
                          <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        </p>
                      </div>
                    </b-field>
                  </div>

                  <div class="field mt-5  ">

                    <label :class="`${$root.selectedLanguage === `ta`
                                  ? `ta-label`
                                  : $root.selectedLanguage === `si`
                                    ? `si-label`
                                    : ``
                                  }`">{{ $root.selectedLanguageData.publicPositionsHeldbyCloserRelativeOrAssociate
                      }}</label>
                    <div class="columns">
                      <div class="column is-one-two" v-if="$root.formData.guardian_closer_relatives_politically_exposed == true">
                        <b-field>
                          <b-radio name="PublicPositionsHeldBySelfUS" style="font-family: fira400" :native-value="true" disabled
                                   v-model="$root.formData.guardian_closer_relatives_politically_exposed">
                            {{$root.selectedLanguageData.yes}}
                          </b-radio>
                        </b-field>
                      </div>
                      <div class="column is-one-two" v-if="$root.formData.guardian_closer_relatives_politically_exposed == false">
                        <b-field>
                          <b-radio name="PublicPositionsHeldBySelfUS" style="font-family: fira400" :native-value="false" disabled
                                   v-model="$root.formData.guardian_closer_relatives_politically_exposed">
                            {{ $root.selectedLanguageData.no }}
                          </b-radio>
                        </b-field>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4" v-if="$root.formData.guardian_closer_relatives_politically_exposed == true" >
                    <label
                        :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    >{{ $root.selectedLanguageData.name}}
                    </label>
                    <b-field>
                      <div class="field">
                        <p class="control has-icons-right">
                          <b-input
                              type="text"
                              @focus="$inputFocused('guardian_closer_relatives_position')"
                              @input="$inputChanged('guardian_closer_relatives_position')"
                              @blur="$inputBlured('guardian_closer_relatives_position')"
                              disabled
                              v-model="$root.formData.guardian_closer_relatives_position"
                          />
                          <span class="icon is-small is-right">
                          <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25" height="25" />
                        </span>
                        </p>
                      </div>
                    </b-field>
                  </div>
                </div>



<!--                <hr style="background-color: #1b1b1b; height: 1.7px">-->



                <p class="preview-page-title">Purpose</p>

                <!-- Purpose start here -->
                <div class="mt-5 is-one-two">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.purposeOfOpeningtheAccount }}
                  </label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.purpose_of_opening.value"
                    />
                  </b-field>
                </div>
                <!--               purpose end here-->

<!--                if purpose is other-->
                <div class="mt-5 is-one-two" v-if="purpose === 'Other'">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.other_Purpose_of_opening_account }}
                  </label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.other_purpose_of_opening"
                    />
                  </b-field>
                </div>

                <!--source of funds and anticipated transaction volume-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.sourceOfFunds}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.source_of_fund" />
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.anticipated_transaction_volumes}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.anticipated_vol.value" />
                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>
        <!--if source of funds are other-->
                <div class="mt-5 is-one-two" v-if="$root.formData.source_of_fund == 'Other'">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.specify_the_source_of_funds }}
                  </label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.other_source_of_fund"
                    />
                  </b-field>
                </div>
<!--                assets section start here-->
                <div class="field mt-4">
                  <div class="columns">
                      <div class="column">
                        <div class="columns">
                          <label
                              :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                          >{{ $root.selectedLanguageData.assets_held_by_yourself
                            }}<span class="has-text-danger">*</span></label
                          >
                        </div>
                        <div class="columns"  v-if="$root.formData.asset_residential_property === true">
                          <div class="column">
                            <b-checkbox disabled v-model="$root.formData.asset_residential_property"
                                        native-value="Residential Property">
                              Residential Property
                            </b-checkbox>
                          </div>

                          <div disabled class = "column is-3 is-offset-5">
                            <b-field>
                                <b-input disabled v-model="$root.formData.asset_residential_property_value"

                                         min="1"
                                         max="999999999"
                                >
                                </b-input>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns" v-if="$root.formData.asset_financial === true">
                          <div class="column">
                            <b-checkbox disabled v-model="$root.formData.asset_financial"
                                        native-value="Residential Property">
                              Financial Assets
                            </b-checkbox>
                          </div>

                          <div class = "column is-3 is-offset-5" >
                            <b-field>
                              <b-input disabled v-model="$root.formData.asset_financial_value"  placeholder="Rs."

                                       min="1"
                                       max="999999999"
                              >
                              </b-input>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns" v-if="$root.formData.asset_land_buildings === true">
                          <div class="column">
                            <b-checkbox disabled v-model="$root.formData.asset_land_buildings"
                                        native-value="Residential Property">
                              Business
                            </b-checkbox>
                          </div>

                          <div class = "column is-3 is-offset-5" >
                            <b-field>
                              <b-input disabled v-model="$root.formData.asset_land_buildings_value"  placeholder="Rs."

                                       min="1"
                                       max="999999999"
                              >
                              </b-input>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns" v-if="$root.formData.asset_investments_shares === true">
                          <div class="column">
                            <b-checkbox disabled v-model="$root.formData.asset_investments_shares"
                                        native-value="Residential Property">
                              Investment
                            </b-checkbox>
                          </div>

                          <div class = "column is-3 is-offset-5" >
                            <b-field>
                              <b-input disabled v-model="$root.formData.asset_investments_shares_value"  placeholder="Rs."

                                       min="1"
                                       max="999999999"
                              >
                              </b-input>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns" v-if="$root.formData.asset_motor_vehicles === true">
                          <div class="column">
                            <b-checkbox disabled v-model="$root.formData.asset_motor_vehicles"
                                        native-value="Residential Property">
                              Motor Vehicles
                            </b-checkbox>
                          </div>

                          <div class = "column is-3 is-offset-5">
                            <b-field>
                              <b-input disabled v-model="$root.formData.asset_motor_vehicles_value"  placeholder="Rs."

                                       min="1"
                                       max="999999999"
                              >
                              </b-input>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns">
                          <div class = "column">
                            <b-checkbox v-model="$root.formData.asset_other" disabled v-if="$root.formData.asset_other === true"
                                        :native-value= "true"                                                                                                                                                                                                                                              >
                              Other
                            </b-checkbox>
                          </div>


                        </div>

                      </div>
                  </div>
                </div>
<!--                assets section end here-->
<!--                if customer have other assets -->
                <div class="field mt-4" v-if="$root.formData.asset_other">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.specify_the_assets_held_by_yourself}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.other_assets_held" />
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.marketValue}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled="" type="text" v-model="$root.formData.asset_other_value" />
                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>



                <!--source of income and expected turnover-->
                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.source_of_income}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.source_of_income" />
                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.expected_turnover}}
                      </label>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input disabled type="text" v-model="$root.formData.expected_turnover.value" />
                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>

                <!--if source of funds are other-->
                <div class="mt-5 is-one-two" v-if="$root.formData.source_of_income == 'Other'">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.specify_the_source_of_income }}
                  </label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.other_source_of_income"
                    />
                  </b-field>
                </div>



                <!-- Expected mode of transaction start here -->
                <div class="mt-5 is-one-two">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.mode_of_transaction
                    }}</label>
                  <b-field>
                    <b-input
                        disabled
                        v-model="$root.formData.expected_mode_of_transaction"

                    />
                  </b-field>
                </div>
                <!-- Expected mode of transaction end here-->

<!--                if expected mode of transaction is other-->
                <div class="mt-5 is-one-two" v-if="$root.formData.expected_mode_of_transaction== 'Other'">
                  <label
                      :class="`${
                        $root.selectedLanguage === `ta`
                          ? `ta-label`
                          : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`"
                  >{{ $root.selectedLanguageData.other_mode_of_transaction }}
                  </label>
                  <b-field>
                    <b-input
                        disabled
                        type="email"
                        v-model="$root.formData.other_expected_mode_of_transaction"
                    />
                  </b-field>
                </div>


                <hr style="background-color: #1b1b1b; height: 1.7px">

<!--                <p class="preview-page-title">Employment Information</p>-->

                <!--  Saving flow Occupation start here-->
<!--                <div class="mt-5 is-one-two">-->
<!--                  <label-->
<!--                      :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.occupationDesignation-->
<!--                    }}</label>-->
<!--                  <b-field>-->
<!--                    <b-input-->
<!--                        disabled-->
<!--                        type="email"-->
<!--                        v-model="$root.formData.employment_position"-->

<!--                    />-->
<!--                  </b-field>-->
<!--                </div>-->

                <!--         if   Occupation is other start here-->
<!--                <div class="mt-5 is-one-two" v-if="$root.formData.employment_position == 'Other'">-->
<!--                  <label-->
<!--                      :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.specify_the_occupation-->
<!--                    }}</label>-->
<!--                  <b-field>-->
<!--                    <b-input-->
<!--                        disabled-->
<!--                        type="email"-->
<!--                        v-model="$root.formData.employment_position_specify"-->

<!--                    />-->
<!--                  </b-field>-->
<!--                </div>-->

                <!--                name of the employer -->
<!--                <div class="mt-5 is-one-two">-->
<!--                  <label-->
<!--                      :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.nameofEmployerBusiness-->
<!--                    }}</label>-->
<!--                  <b-field>-->
<!--                    <b-input-->
<!--                        disabled-->
<!--                        type="email"-->
<!--                        v-model="$root.formData.employer_name"-->

<!--                    />-->
<!--                  </b-field>-->
<!--                </div>-->


<!--                <div class="mt-5 is-one-two">-->
<!--                  <label-->
<!--                      :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.employerBusinessAddress-->
<!--                    }}</label>-->
<!--                  <b-field>-->
<!--                    <b-input-->
<!--                        disabled-->
<!--                        type="email"-->
<!--                        v-model="$root.formData.employer_addr"-->

<!--                    />-->
<!--                  </b-field>-->
<!--                </div>-->

<!--                <hr style="background-color: #1b1b1b; height: 1.7px">-->
<!--                <p class="preview-page-title mb-3">{{$root.selectedLanguageData.valueAddedServices}}</p>-->

<!--                <b-field class="columns">-->
<!--                  <label class="column"-->
<!--                         :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.smsAlerts-->
<!--                    }}</label>-->
<!--                  <b-switch class="column" disabled :value="$root.formData.sms_service" />-->
<!--                </b-field>-->

<!--                <b-field class="columns">-->
<!--                  <label class="column"-->
<!--                         :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.internetbanking-->
<!--                    }}</label>-->
<!--                  <b-switch class="column" disabled :value="$root.formData.e_banking_service" />-->
<!--                </b-field>-->

<!--                <b-field class="columns">-->
<!--                  <label class="column"-->
<!--                         :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.virtualWallet }}</label>-->
<!--                  <b-switch class="column" disabled :value="$root.formData.virtual_wallet_service" />-->
<!--                </b-field>-->

<!--                <b-field class="columns">-->
<!--                  <label class="column"-->
<!--                         :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.estatement-->
<!--                    }}</label>-->
<!--                  <b-switch class="column" disabled :value="$root.formData.estatement_service" />-->
<!--                </b-field>-->

<!--                <b-field class="columns">-->
<!--                  <label class="column"-->
<!--                         :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                  >{{ $root.selectedLanguageData.debitCard }}</label>-->
<!--                  <b-switch class="column" disabled :value="$root.formData.debit_card_service" />-->
<!--                </b-field>-->


<!--                <div v-if="$root.formData.debit_card_service == true">-->
<!--                  &lt;!&ndash; this div only for debit card users &ndash;&gt;-->
<!--                  <div class="mt-3">-->
<!--                    <label-->
<!--                        :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                    >{{-->
<!--                        $root.selectedLanguageData-->
<!--                            .nameThatShouldAppearOnTheCard-->
<!--                      }}</label-->
<!--                    >-->
<!--                    <b-field>-->
<!--                      <b-input-->
<!--                          type="text"-->
<!--                          disabled-->
<!--                          v-model="-->
<!--                            $root.formData.facility_debit_card_customer_name-->
<!--                          "-->
<!--                      />-->
<!--                    </b-field>-->
<!--                  </div>-->

<!--                  <div class="mt-3">-->
<!--                    <label-->
<!--                        :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                    >{{$root.selectedLanguageData.maiden_name}}-->

<!--                    </label>-->
<!--                    <b-field>-->
<!--                      <b-input-->
<!--                          type="text"-->
<!--                          disabled-->
<!--                          v-model="$root.formData.mother_maiden_name "/>-->
<!--                    </b-field>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; card type select preview&ndash;&gt;-->
<!--                  <div class="mt-3">-->
<!--                    <label-->
<!--                        :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                    >{{ $root.selectedLanguageData.selectTheCardType }}-->
<!--                    </label>-->
<!--                    <b-field>-->
<!--                      <b-radio-->
<!--                          v-if="$root.formData.facility_debit_card_type ===`Visa Card`"-->
<!--                          style="font-family: fira400"-->
<!--                          disabled-->
<!--                          checked>-->
<!--                        <span-->
<!--                        ><img-->
<!--                            src="@/assets/images/icons/CardImages/Visa.webp"-->
<!--                            alt="visa-img"-->
<!--                            width="50px"/>-->
<!--                      </span>-->
<!--                        {{ $root.selectedLanguageData.visaCard }}-->
<!--                      </b-radio>-->
<!--                      <b-radio-->
<!--                          v-if="$root.formData.facility_debit_card_type ===`Mastercard`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked-->
<!--                          disabled>-->
<!--                        <span>-->
<!--                          <img-->
<!--                              src="@/assets/images/icons/CardImages/Visa.webp"-->
<!--                              alt="mastercard-img"-->
<!--                              width="50px"/>-->
<!--                        </span>-->
<!--                      </b-radio>-->
<!--                      <b-radio-->
<!--                          v-if="$root.formData.facility_debit_card_type ===`JCBcard`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked-->
<!--                          disabled>-->
<!--                        <span>-->
<!--                          <img-->
<!--                              src="@/assets/images/icons/CardImages/JCB.png"-->
<!--                              alt="jcb-card-img"-->
<!--                              width="50px"/>-->
<!--                        </span>-->
<!--                      </b-radio>-->
<!--                    </b-field>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; card preview end&ndash;&gt;-->

<!--                  <div class="mt-3">-->
<!--                    <label-->
<!--                        :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                    >{{ $root.selectedLanguageData.card_delivery_detail-->
<!--                      }}</label>-->
<!--                    <b-field>-->
<!--                      <b-radio-->
<!--                          v-if="$root.formData.card_delivery ===`Collect from branch`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked disabled>-->
<!--                        {{ $root.selectedLanguageData.collectFromBranch }}-->
<!--                      </b-radio>-->
<!--                      <b-radio-->
<!--                          v-if="-->
<!--                          $root.formData.card_delivery ===`Permanent Address`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked disabled>-->
<!--                        {{ $root.selectedLanguageData.permanentAddress }}-->
<!--                      </b-radio>-->
<!--                    </b-field>-->
<!--                  </div>-->

<!--                  <div class="mt-3">-->
<!--                    <label-->
<!--                        :class="`${-->
<!--                        $root.selectedLanguage === `ta`-->
<!--                          ? `ta-label`-->
<!--                          : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`"-->
<!--                    >{{ $root.selectedLanguageData.pin_delivery_details-->
<!--                      }}</label>-->
<!--                    <b-field>-->
<!--                      <b-radio-->
<!--                          v-if="$root.formData.card_delivery ===`Collect from branch`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked disabled>-->
<!--                        {{ $root.selectedLanguageData.collectFromBranch }}-->
<!--                      </b-radio>-->
<!--                      <b-radio-->
<!--                          v-if="-->
<!--                          $root.formData.card_delivery ===`Permanent Address`"-->
<!--                          style="font-family: fira400"-->
<!--                          checked disabled>-->
<!--                        {{ $root.selectedLanguageData.permanentAddress }}-->
<!--                      </b-radio>-->
<!--                    </b-field>-->
<!--                  </div>-->
<!--                </div>-->


                <!-- document images section-->
<!--                <hr style="background-color: #1b1b1b; height: 1.7px" />-->
             <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.birth_certificate_front_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.birthCertificateFrontSideImage }}
                    </label>
                    <img :src="$root.imageurl.birth_certificate_front_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two" v-if="$root.imageurl.birth_certificate_back_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.birthCertificateBackSideImage}}
                    </label>
                    <img :src="$root.imageurl.birth_certificate_back_imageurl" class="image-box"/>
                  </div>
                </div>

                <!--NIC FRONT & BACK-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.nicfrontsideimageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.nicfrontsideimage }}
                    </label>
                    <img :src="$root.imageurl.nicfrontsideimageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two" v-if="$root.imageurl.nicbacksideimageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.nicbacksideimage}}
                    </label>
                    <img :src="$root.imageurl.nicbacksideimageurl" class="image-box"/>
                  </div>
                </div>

                <!--DRIVING LICENSE-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.driving_licence_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.driving_licence }}
                    </label>
                    <img :src="$root.imageurl.driving_licence_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two">
                  </div>
                </div>

                <!--PASSPORT IMAGES-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.passport_bio_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.passportbiopage }}
                    </label>
                    <img :src="$root.imageurl.passport_bio_page_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two" v-if="$root.imageurl.passport_alteration_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.passportalterationpage }}
                    </label>
                    <img :src="$root.imageurl.passport_alteration_page_imageurl" class="image-box"/>
                  </div>
                </div>


                <!--PASSPORT ENTRY STAMP-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.passport_entry_stamp_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.passportentrystamppage }}
                    </label>
                    <img :src="$root.imageurl.passport_entry_stamp_page_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two">
                  </div>
                </div>

                <!--GUARDIAN PASSPORT IMAGES-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.guardian_passport_bio_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.guardianpassportbiopage }}
                    </label>
                    <img :src="$root.imageurl.guardian_passport_bio_page_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two" v-if="$root.imageurl.guardian_passport_alteration_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.guardianpassportalterationpage }}
                    </label>
                    <img :src="$root.imageurl.guardian_passport_alteration_page_imageurl" class="image-box"/>
                  </div>
                </div>


                <!--GUARDIAN PASSPORT ENTRY STAMP-->
                <div class="columns">
                  <div class="column is-one-two" v-if="$root.imageurl.guardian_passport_entry_stamp_page_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.guardianpassportentrystamppage }}
                    </label>
                    <img :src="$root.imageurl.guardian_passport_entry_stamp_page_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two">
                  </div>
                </div>

















                <!--SELFIE AND SIGNAUTRE IMAGES-->
                <div class="columns">
                  <div class="column is-one-two"  v-if="$root.imageurl.selfie_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.selfieimage }}
                    </label>
                    <img :src="$root.imageurl.selfie_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two"  v-if="$root.imageurl.signature_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.signatureimage }}
                    </label>
                    <img :src="$root.imageurl.signature_imageurl" class="image-box"/>
                  </div>
                </div>

                <!--ADDRESS PROOF IMAGE-->
                <div class="columns">
                  <div class="column is-one-two"  v-if="$root.imageurl.address_proof_imageurl">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{$root.selectedLanguageData.proofofaddress }}
                    </label>
                    <img :src="$root.imageurl.address_proof_imageurl" class="image-box"/>
                  </div>
                  <div class="column is-one-two">
                  </div>
                </div>



                <hr style="background-color: #1b1b1b; height: 1.7px">

                <p class="preview-page-title">Video Call Details</p>

                <div class="field mt-4">
                  <div class="columns">
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.preferreddate}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input disabled
                                   type="text" :value=dateFormat($root.formData.videoCallDate) />
                          <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                        </p>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        {{ $root.selectedLanguageData.preferredtime}}

                      </label>
                      <b-field>
                        <p class="control has-icons-right">

                          <b-input disabled type="text" v-model="$root.formData.videoCallTimeSlot" />
                          <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />
                            </span>

                        </p>
                      </b-field>
                    </div>
                  </div>
                </div>


                <div  v-if="$root.isPreviouslyDonorFilled === 1">
                  <hr style="background-color: #1b1b1b; height: 1.7px">
                  <p class="preview-page-title mb-2">Donor’s Information</p>

                  <!--                Donor name-->
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.donor_name }}
                    </label>
                    <b-field>
                      <b-input type="text" v-model="$root.formData.donorsName" />
                    </b-field>
                  </div>

                   <div class="columns mt-2">
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="donor residence" style="font-family: fira400"
                                 disabled
                                 native-value="Resident in Sri Lanka"
                                 v-model="$root.formData.donorResidentship">
                          {{$root.selectedLanguageData.residentInSriLanka }}
                        </b-radio>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="donor residence" style="font-family: fira400"
                                 disabled
                                 native-value="Non Resident"
                                 v-model="$root.formData.donorResidentship">
                          {{ $root.selectedLanguageData.nonResident }}
                        </b-radio>
                      </b-field>
                    </div>
                  </div>

                   <div v-if="$root.formData.donorResidentship ===`Non Resident` ">
                    <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.residency }}
                    </label>
                    <b-field>
                      <b-input type="text" v-model="$root.formData.donorResidentship" />
                    </b-field>
                  </div>

                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                      {{ $root.selectedLanguageData.donorPermanentAddress }}
                    </label>
                    <!--permanent address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>

                        <p class="control has-icons-right">
                          <b-input disabled type="text"
                                   v-model="$root.formData.donor_permanent_address_line1"></b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25" height="25" />
                          </span>
                        </p>


                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--permanent address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.donor_permanent_address_line2"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--permanent address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>

                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.donor_permanent_address_line3"></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>


                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--permanent address postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input disabled type="text"
                                     v-model="$root.formData.donor_permanent_address_postal_code">
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>
                      <!--permanent address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-select disabled v-model="$root.formData.donor_permanent_address_country" expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--                donor mailing address-->
                  <div class="mt-4">
                    <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                      {{ $root.selectedLanguageData.donorMailingAddress }}</label>
                    <b-field>
                      <b-checkbox type="is-primary"
                                  v-model="$root.formData.donor_mailing_address_same_as_permanent_address"
                                  disabled>
                        {{$root.selectedLanguageData.sameAsPermanentAddress }}
                      </b-checkbox>
                    </b-field>

                    <!--mailing address house name-->
                    <div class="mt-1">
                      <p>
                        {{ $root.selectedLanguageData.houseName }}

                      </p>
                      <b-field>
                        <p class="control has-icons-right">
                          <b-input type="text"
                                   v-model="$root.formData.donor_mailing_address_line1"
                                   disabled>
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>

                      </b-field>
                    </div>

                    <div class="columns is-7 is-variable mt-2">
                      <!--mailing address street name-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.streetName }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.donor_mailing_address_line2"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                      <!--mailing address city-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.city }}

                        </p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text" v-model="$root.formData.donor_mailing_address_line3"
                                     disabled></b-input>
                            <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                          </p>

                        </b-field>
                      </div>
                    </div>
                    <div class="columns is-7 is-variable">
                      <!--mailing postal code-->
                      <div class="column">
                        <p>{{ $root.selectedLanguageData.postalCode }}</p>
                        <b-field>
                          <p class="control has-icons-right">
                            <b-input type="text"
                                     v-model="$root.formData.donor_mailing_address_postal_code"
                                     disabled>
                            </b-input>
                            <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                          </p>
                        </b-field>
                      </div>

                      <!--mailing address country-->
                      <div class="column">
                        <p>
                          {{ $root.selectedLanguageData.country }}

                        </p>
                        <div>
                          <div style="width: 100%">
                            <b-select
                                v-model="$root.formData.donor_mailing_address_country"
                                disabled expanded>
                              <option v-for="country in $root.selectedLanguageData.countries"
                                      :key="country.value"
                                      :value="country.value">
                                {{ country.countryName }}
                              </option>
                            </b-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </transition>
          </div>

          <transition
              appear
              @before-enter="$animations.beforeEnterBelow"
              @enter="$animations.enterBelow"
          >
            <div class="is-centered columns mb-3">
              <div
                  class="column is-6 is-offset-5 is-flex is-flex-direction-row-reverse "

              >
                <b-button
                    :class="`is-primary ${
                    $root.selectedLanguage === `ta`
                      ? `continue-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `continue-button-si`
                      : `continue-button-en`
                  }`"
                    :disabled="invalid"
                    @click="submitPageInputs(isContinueButtonLoading, 'verification', 'preview-page', 'verification', 1)"
                >{{ $root.selectedLanguageData.continue }}
                </b-button>
                <b-button
                    :class="` ${
                    $root.selectedLanguage === `ta`
                      ? `back-button-ta`
                      : $root.selectedLanguage === `si`
                      ? `back-button-si`
                      : `back-button-en`
                  }`"
                    @click="$router.go(-1)"
                >{{ $root.selectedLanguageData.back }}</b-button
                >
              </div>
            </div>
          </transition>
        </form>
      </ValidationObserver>
    </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import "../validate.js";
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";
import NomineesInfo from  "./supports/page-section/NomineesInfo.vue"
// import selfieSample from "../assets/images/icons/Yellow/selfie_sample.png";
export default {
  components: {
    GetHelp,
    Logo,
    NomineesInfo,
  },
  data() {
    return {
      maxDate: new Date(),
      purpose: "",
      countriesArray: [],
      countriesListArray: [],
      iconString: "",
      countryIconString: "",
      iconStringOffice: "",
      iconStringUs: "",
      iconStringUsGuardian : "",
      // selfieImageSample: selfieSample,
      politically_exposed_relative: "",
      // dualCitizenshipTextArea:
      //   this.$root.formData.sriLankan_with_citizenshipCountries.toString(),
      foreignNationalWithDualCitizenshipTextArea:
          this.$root.formData.dual_citizen_countries.toString(),
      purposeTextArea: this.$root.formData.purpose_of_opening.toString(),
      videoCallDate: "",
      submitPageInputs :submitPageInputs,
      isContinueButtonLoading : false,

      regex: {
        old_nic: /^([0-9]{9}[Xx||Vv])$/,
        passport: /^[0-9A-Za-z]{4,18}$/,
        new_nic: /[0-9]{12}/,
      },

      // accounts: [
      //   {
      //     id: 1,
      //     name: 'kekulu',
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'savings',
      //     account: "Minor Savings"
      //   },
      //   {
      //     id: 2,
      //     name: '4 teen plus',
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'savings',
      //     account: "Minor Savings"
      //   },
      //   {
      //     id: 3,
      //     name: '14 plus',
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'savings',
      //     account: "Minor Savings"
      //   },
      //   {
      //     id: 4,
      //     name: '4 teen ',
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'savings',
      //     account: "Minor Savings"
      //   },
      //   {
      //     id: 5,
      //     name: "Liya sevena",
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: "savings",
      //     account: 'Normal Savingss'
      //   },
      //   {
      //     id: 6,
      //     name: "RDB Max",
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'fix deposit',
      //     account: "Fixed Accounts"
      //   },
      //   {
      //     id: 7,
      //     name: "RDB Fix Deposit",
      //     imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
      //     account_type: 'fix deposit',
      //     account: "Fixed Accounts"
      //   }
      // ],

      accounts: [
        {
          id: 1,
          name: 'RDB Max',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Max.png`),
          account_type: '',
          account: "Fixed Accounts"
        },
        // {
        //   id: 2,
        //   name: '4 teen plus',
        //   imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
        //   account_type: 'savings',
        //   account: "Normal Savingss"
        // },
        // {
        //   id: 3,
        //   name: '14 plus',
        //   imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
        //   account_type: 'savings',
        //   account: "Minor Savings"
        // },
        {
          id: 4,
          name: 'RDB 4 teen plus ',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB 4 teen Plus.png`),
          account_type: 'savings',
          account: "Minor Savings"
        },
        {
          id: 5,
          name: "RDB Liya saviya",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Liya Saviya.png`),
          account_type: "savings",
          account: 'Normal Savingss'
        },
        {
          id: 6,
          name: "RDB Liya saviya Plus",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Liya Saviya Plus.png`),
          account_type: 'savings',
          account: "Investment Savingss"
        },
        {
          id: 7,
          name: "RDB Uththama",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Uththama.png`),
          account_type: 'savings',
          account: "Normal Savingss"
        },
        {
          id: 8,
          name: "RDB Ayojana",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Ayojana.png`),
          account_type: 'savings',
          account: "Investment Savingss"
        },

        {
          id: 9,
          name: 'RDB Fix Deposit',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Fixed Deposits.png`),
          account_type: '',
          account: "Fixed Accounts"
        },
        {
          id: 10,
          name: 'RDB Victory',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Victory.png`),
          account_type: 'savings',
          account: "Normal Savingss"
        },
        {
          id: 11,
          name: 'RDB NewLife',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB New Life.png`),
          account_type: 'savings',
          account: "Normal Savingss"
        },
      ],

      myOptions: {
        layout: {
          color: "black",
          backgroundColor: "#c4c4c41a",
          selectedColor: "black",
          selectedBackgroundColor: "#009ec2",
          borderColor: "black",
          fontWeight: "normal",
          fontWeightSelected: "bold",
        },
        size: {
          fontSize: 14,
          height: 2.5,
          // padding: 2,
          width: 13,
        },
        config: {
          delay: 0.2,
          preSelected: `${
              this.$root.formData.gender ? this.$root.formData.gender : "Male"
          }`,
          disabled: false,
          items: [
            {
              name: this.$root.selectedLanguageData.male,
              value: "Male",
              color: "black",
            },
            {
              name: this.$root.selectedLanguageData.female,
              value: "Female",
              color: "black",
            },
          ],
        },
      },
    };
  },
  methods: {
    /***
     * This function is used to set changing each gender name according to changing language data
     * @param languageData
     * @returns {*|{layout: {backgroundColor: string, borderColor: string, color: string, selectedBackgroundColor: string, fontWeightSelected: string, selectedColor: string, fontWeight: string}, size: {width: number, fontSize: number, height: number}, config: {delay: number, disabled: boolean, preSelected: string, items: [{color: string, name: *, value: string},{color: string, name: *, value: string}]}}|{layout: {backgroundColor: string, borderColor: string, color: string, selectedBackgroundColor: string, fontWeightSelected: string, selectedColor: string, fontWeight: string}, size: {width: number, fontSize: number, height: number}, config: {delay: number, disabled: boolean, preSelected: string, items: [{color: string, name: string, value: string},{color: string, name: string, value: string}]}}}
     */

    accountFilter(acctype) {
      return this.accounts.filter(account => account.account === acctype);

    },

    dateFormat(DateValue){
      let date = new Date(DateValue);
      let year  = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day   = date.getDate().toString().padStart(2, "0");

      return year + '-' + month + '-' + day;
    },

    getFullname(){
      let otherName;
      let title;
      let surName;
      if(this.$root.formData.account === `Minor Savings` || this.$root.formData.haveNic === 'No'){
            otherName = this.$root.formData.guardian_other_name
            title = this.$root.formData.guardian_title
            surName = this.$root.formData.guardian_surname
      }
      else
      {otherName = this.$root.formData.other_name
      title = this.$root.formData.title
      surName = this.$root.formData.surname
      }

      return title +'. '+ otherName +' '+ surName
    },

    getMyOptions(languageData) {
      const comp = this;
      let options = comp.myOptions;
      options.config.items[0].name = languageData.male;
      options.config.items[1].name = languageData.female;

      return options;
    },

    changeSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
          (countryObject) =>
              countryObject.phone === this.$root.formData.countryCode
      );
      this.iconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },
    changeResidentialSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
          (countryObject) =>
              countryObject.phone ===
              this.$root.formData.countryCodeForResidentialContactNum
      );

      this.countryIconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    changeOfficeContactNumCountryCode() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
          (countryObject) =>
              countryObject.phone ===
              this.$root.formData.countryCodeForOfficeContactNum
      );
      this.iconStringOffice = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },
    changeUsContactNumCountryCode() {
      this.iconStringUs = `fi fi-${this.$root.formData.usTellCountryCode.toLowerCase()}`;
    },
    usCountryCodeList() {
      if (this.$root.formData.us_person === `Yes`) {
        this.countriesListArray = this.$root.formData.countriesList.filter(
            (item) => item.code !== "LK"
        );
      }
    },
    calGuardianUsContactNumber() {
      const code = this.$root.formData.countriesList.find(
        (item) => item.code === this.$root.formData.guardianUsTellCountryCode
      );
      this.$root.formData.guardian_us_person_telephone_no = `${code.phone}${this.$root.formData.guardian_us_tel_number}`;
    },

    validateFullName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: " ",
      };
      return obj;
    },
    validateNameWithInitials() {
      const obj = {
        required: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: ".",
      };
      return obj;
    },
    nicValidateObject: function () {
      const comp = this;
      let obj = {
        required: true,
      };

      if (comp.$root.formData.idType === "ONIC") {
        obj.regex = comp.regex.old_nic;
      } else if (comp.$root.formData.idType === "NNIC") {
        obj.regex = comp.regex.new_nic;
      } else {
        obj.regex = comp.regex.passport;
      }
      return obj;
    },
      changeGuardianUsContactNumCountryCode() {
      this.iconStringUsGuardian = `fi fi-${this.$root.formData.guardianUsTellCountryCode.toLowerCase()}`;
    },

    updateLastStep() {
      try {
        window.element = this;
        let kyc_token =
            this.$root.formData.kyc_token +
            "." +
            this.$root.formData.color_code4 +
            "." +
            this.$root.formData.color_code12;
        this.$http
            .post(
                this.$baseURL + "/kycForm/updateLastStep",
                {
                  last_step_name:'Video Call Details',
                  last_step: 9,
                  form_filled:true,
                  next_route:'Employment Info',
                },
                {
                  headers: { "X-token": kyc_token },
                }
            )
            .then((response) => {
              console.log(response.data);

              if (response.data.success) {
                console.log(response.data);
              } else {
                console.log(response.data);
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
  },
  watch: {
    "$root.selectedLanguage": function () {
      if (
          this.$root.formData.purpose_of_opening.langTranslation !== this.purpose
      ) {
        this.$root.formData.purpose_of_opening = "";
        this.purpose = "";
      } else {
        const purposeValue = this.$root.formData.purpose_of_opening.value;
        const purposeOption = this.$root.selectedLanguageData.purposeList.find(
            (search) => search.value === purposeValue
        );
        this.purpose = purposeOption.langTranslation;
        this.$root.formData.purpose_of_opening = purposeOption;
      }
      // SourceOfIncome
      const tempSourceOfIncome = this.$root.formData.source_of_income.value;
      const tempSourceOfIncomeObject =
          this.$root.selectedLanguageData.sourceOfIncomeList.find(
              (search) => search.value === tempSourceOfIncome
          );
      this.$root.formData.source_of_income = tempSourceOfIncomeObject;
      // anticipated_vol
      const tempAnticipatedVol = this.$root.formData.anticipated_vol.value;
      const tempAnticipatedVolObject =
          this.$root.selectedLanguageData.anticipatedDepositsAmountList.find(
              (search) => search.value === tempAnticipatedVol
          );
      this.$root.formData.anticipated_vol = tempAnticipatedVolObject;
      // expected_delivery_channel
      const tempExpectedDelivery =
          this.$root.formData.expected_delivery_channel.value;
      const tempExpectedDeliveryObject =
          this.$root.selectedLanguageData.expectedModeOfTransactionList.find(
              (search) => search.value === tempExpectedDelivery
          );
      this.$root.formData.expected_delivery_channel =
          tempExpectedDeliveryObject;
      // income_details
      const tempIncomeDetails = this.$root.formData.income_details.value;
      const tempIncomeDetailsObject =
          this.$root.selectedLanguageData.incomeDetailsList.find(
              (search) => search.value === tempIncomeDetails
          );
      this.$root.formData.income_details = tempIncomeDetailsObject;
    },
  },
  computed: {
    filteredDataArray() {
      return this.$root.selectedLanguageData.purposeList.filter((option) => {
        return (
            option.value.toLowerCase().indexOf(this.purpose.toLowerCase()) >= 0
        );
      });
    },
  },
  mounted: function () {
    this.usCountryCodeList();
    // this.updateLastStep();
    this.changeSelection();
    this.changeResidentialSelection();
    this.changeOfficeContactNumCountryCode();
    this.changeUsContactNumCountryCode();
    this.changeGuardianUsContactNumCountryCode();
    this.countriesArray = this.$root.selectedLanguageData.countries.filter(
        (item) => item.value !== "Sri Lanka"
    );
    if (this.$root.formData.purpose_of_opening) {
      const purposeValue = this.$root.formData.purpose_of_opening.value;
      const purposeOption = this.$root.selectedLanguageData.purposeList.find(
          (search) => search.value === purposeValue
      );
      this.purpose = purposeOption.langTranslation;
    }
  },
};
</script>
<style scoped>
.image-box {
  border: 2px solid #009ec2;
  width: 280px;
  height: 250px;
}
.verticalLine {
  border-left: 0.92px solid #1b1b1b;
}
.round-image-box {
  border-radius: 50%;
  border: 2px solid #009ec2;
  width: 250px;
  height: 180px;



}
.px-6 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
  width:60%;
  margin:auto;

}
.emailText{
  font-size: 1.2rem;

}
.nameSize{

  font-size:1.7rem;
  font-family:OpenSans-Regular;
  letter-spacing:0.5px;


}
.mobileSize{

  font-size: 1.2rem;
  width:100vw;


}

@media (max-width: 500px) {
  /* Adjust the margin-top for the mobile view */
  .ml-4 {
    margin-top: 10px; /* Adjust the value as needed */
  }

  .round-image-box {
    border-radius: 50%;
    border: 2px solid #009ec2;
    /*width: 250px;*/
    height: 180px;
    margin:0 5%;

  }
  .px-6 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    width: 75%;

  }
  .mt-6 {
    margin-top: 1rem !important;
  }
  .emailText{
    font-size: 0.9rem;
    word-wrap: break-word;

  }
  .content-container{
    margin-top: 20px;
  }
  .flexName{

      display: block !important;

  }
  .nameSize{
      font-size: 0.8rem;

  }
  .mobileSize{
      font-size: 0.8rem;
      width:70vw;
  }



}
</style>
